var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);

// js/util.js
function executeCommand(hook, command) {
  if (typeof command === "string" && command.trim()) {
    hook.js().exec(command);
    return true;
  }
  return false;
}

// js/hooks/action_menu.js
var TAB = "Tab";
var DOWN = "ArrowDown";
var action_menu_default = {
  mounted() {
    this._abortController = new AbortController();
    const menu = this.el.querySelector("[role=menu]");
    const trigger = this.el.querySelector("[popovertarget]");
    const popover = this.el.querySelector("[popover]");
    trigger.addEventListener(
      "keydown",
      (event) => {
        if (!popover.matches(":popover-open")) return;
        if (event.key === TAB || event.key === DOWN) {
          const firstItem = menu.querySelector("a, button:not([disabled])");
          if (firstItem !== null) {
            event.preventDefault();
            firstItem.focus({ visible: true });
          }
        }
      },
      {
        signal: this._abortController.signal
      }
    );
    popover.addEventListener(
      "focusout",
      (event) => {
        if (event.relatedTarget && this.el.contains(event.relatedTarget)) return;
        executeCommand(this, this.el.dataset.hideDisclosure);
      },
      {
        signal: this._abortController.signal
      }
    );
    popover.addEventListener(
      "toggle",
      (event) => {
        trigger.setAttribute("aria-expanded", event.newState === "open" ? "true" : "false");
      },
      {
        signal: this._abortController.signal
      }
    );
    this.el.setAttribute("data-ready", "true");
  },
  updated() {
    const popover = this.el.querySelector("[popover]");
    if (popover && popover.matches(":popover-open")) {
      this.el.querySelector("[popovertarget]").setAttribute("aria-expanded", "true");
    }
  },
  destroyed() {
    this._abortController.abort();
  }
};

// js/hooks/button_group.js
var KEYS = {
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight"
};
var button_group_default = {
  mounted() {
    this.abortController = new AbortController();
    this.el.addEventListener("keydown", this._handleKeydown.bind(this), {
      signal: this.abortController.signal
    });
  },
  destroyed() {
    var _a;
    (_a = this.abortController) == null ? void 0 : _a.abort();
  },
  _handleKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS.LEFT]: () => {
        event.preventDefault();
        this._moveFocus(false);
      },
      [KEYS.RIGHT]: () => {
        event.preventDefault();
        this._moveFocus();
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _moveFocus(isForward = true) {
    var _a, _b;
    const buttons = Array.from(this.el.querySelectorAll("button:not([disabled])"));
    if (buttons.length === 0) return;
    const currentIndex = buttons.findIndex((btn) => btn === document.activeElement);
    if (currentIndex === -1) {
      (_a = buttons[0]) == null ? void 0 : _a.focus();
      return;
    }
    const nextIndex = isForward ? (currentIndex + 1) % buttons.length : (currentIndex - 1 + buttons.length) % buttons.length;
    (_b = buttons[nextIndex]) == null ? void 0 : _b.focus();
  }
};

// js/hooks/cancel_input.js
var cancel_input_default = {
  mounted() {
    this._input = this.el.querySelector("input");
    this._cancelBtn = this.el.querySelector(`#${this._input.id}-cancel`);
    this._searchIcon = this.el.querySelector(`#${this._input.id}-search`);
    this._handleInputChange();
    this._cancelBtn.addEventListener("click", this._handleCancelBtnClick.bind(this));
    this._input.addEventListener("keyup", this._handleInputChange.bind(this));
  },
  _showCancelBtn() {
    this._cancelBtn.removeAttribute("hidden");
    this._searchIcon.setAttribute("hidden", "");
  },
  _hideCancelBtn() {
    this._searchIcon.removeAttribute("hidden");
    this._cancelBtn.setAttribute("hidden", "");
  },
  _handleCancelBtnClick() {
    this._input.value = "";
    this._input.focus();
    if (this._input.dataset.clearInput) {
      this.js().exec(this._input.dataset.clearInput);
    } else {
      const hasDebounce = this._input.hasAttribute("phx-debounce");
      const debounce = hasDebounce ? this._input.getAttribute("phx-debounce") : null;
      if (hasDebounce) this._input.removeAttribute("phx-debounce");
      this._input.dispatchEvent(new Event("input", { bubbles: true }));
      if (hasDebounce) this._input.setAttribute("phx-debounce", debounce);
    }
    this._hideCancelBtn();
  },
  _handleInputChange() {
    if (this._input.value === "") {
      this._hideCancelBtn();
    } else {
      this._showCancelBtn();
    }
  },
  updated() {
    this._handleInputChange();
  }
};

// node_modules/cally/dist/cally.js
var _t, _e;
var le = class {
  /**
   * @param {T} current
   */
  constructor(t) {
    /**
     * @type {T}
     */
    __privateAdd(this, _t);
    __privateAdd(this, _e, /* @__PURE__ */ new Set());
    __privateSet(this, _t, t);
  }
  /**
   * @return {T}
   */
  get current() {
    return __privateGet(this, _t);
  }
  /**
   * @param {T} value
   */
  set current(t) {
    __privateGet(this, _t) != t && (__privateSet(this, _t, t), __privateGet(this, _e).forEach((n) => n(t)));
  }
  /**
   * @type {import("hooks").Ref["on"]}
   */
  on(t) {
    return __privateGet(this, _e).add(t), () => __privateGet(this, _e).delete(t);
  }
};
_t = new WeakMap();
_e = new WeakMap();
var Rt = (e) => new le(e);
var st = Symbol.for("atomico.hooks");
globalThis[st] = globalThis[st] || {};
var A = globalThis[st];
var ue = Symbol.for("Atomico.suspense");
var Yt = Symbol.for("Atomico.effect");
var fe = Symbol.for("Atomico.layoutEffect");
var Ft = Symbol.for("Atomico.insertionEffect");
var R = (e, t, n) => {
  const { i: s, hooks: o } = A.c, r = o[s] = o[s] || {};
  return r.value = e(r.value), r.effect = t, r.tag = n, A.c.i++, o[s].value;
};
var It = (e) => R((t = Rt(e)) => t);
var W = () => R((e = Rt(A.c.host)) => e);
var Lt = () => A.c.update;
var de = (e, t, n = 0) => {
  let s = {}, o = false;
  const r = () => o, a = (l, c) => {
    for (const d in s) {
      const i = s[d];
      i.effect && i.tag === l && (i.value = i.effect(i.value, c));
    }
  };
  return { load: (l) => {
    A.c = { host: t, hooks: s, update: e, i: 0, id: n };
    let c;
    try {
      o = false, c = l();
    } catch (d) {
      if (d !== ue) throw d;
      o = true;
    } finally {
      A.c = null;
    }
    return c;
  }, cleanEffects: (l) => (a(Ft, l), () => (a(fe, l), () => {
    a(Yt, l);
  })), isSuspense: r };
};
var x = Symbol.for;
function xt(e, t) {
  const n = e.length;
  if (n !== t.length) return false;
  for (let s = 0; s < n; s++) {
    let o = e[s], r = t[s];
    if (o !== r) return false;
  }
  return true;
}
var M = (e) => typeof e == "function";
var F = (e) => typeof e == "object";
var { isArray: he } = Array;
var ot = (e, t) => (t ? e instanceof HTMLStyleElement : true) && "hydrate" in ((e == null ? void 0 : e.dataset) || {});
function _t2(e, t) {
  let n;
  const s = (o) => {
    let { length: r } = o;
    for (let a = 0; a < r; a++) {
      const u = o[a];
      if (u && Array.isArray(u))
        s(u);
      else {
        const f = typeof u;
        if (u == null || f === "function" || f === "boolean")
          continue;
        f === "string" || f === "number" ? (n == null && (n = ""), n += u) : (n != null && (t(n), n = null), t(u));
      }
    }
  };
  s(e), n != null && t(n);
}
var jt = (e, t, n) => (e.addEventListener(t, n), () => e.removeEventListener(t, n));
var Bt = class {
  /**
   *
   * @param {HTMLElement} target
   * @param {string} message
   * @param {string} value
   */
  constructor(t, n, s) {
    this.message = n, this.target = t, this.value = s;
  }
};
var qt = class extends Bt {
};
var me = class extends Bt {
};
var z = "Custom";
var ye = null;
var pe = { true: 1, "": 1, 1: 1 };
function ge(e, t, n, s, o) {
  const {
    type: r,
    reflect: a,
    event: u,
    value: f,
    attr: l = be(t)
  } = (n == null ? void 0 : n.name) != z && F(n) && n != ye ? n : { type: n }, c = (r == null ? void 0 : r.name) === z && r.map, d = f != null ? r == Function || !M(f) ? () => f : f : null;
  Object.defineProperty(e, t, {
    configurable: true,
    /**
     * @this {import("dom").AtomicoThisInternal}
     * @param {any} newValue
     */
    set(i) {
      const m = this[t];
      d && r != Boolean && i == null && (i = d());
      const { error: g, value: b } = (c ? Te : Ee)(
        r,
        i
      );
      if (g && b != null)
        throw new qt(
          this,
          `The value defined for prop '${t}' must be of type '${r.name}'`,
          b
        );
      m != b && (this._props[t] = b != null ? b : void 0, this.update(), u && zt(this, u), this.updated.then(() => {
        a && (this._ignoreAttr = l, De(this, r, l, this[t]), this._ignoreAttr = null);
      }));
    },
    /**
     * @this {import("dom").AtomicoThisInternal}
     */
    get() {
      return this._props[t];
    }
  }), d && (o[t] = d()), s[l] = { prop: t, type: r };
}
var zt = (e, _a) => {
  var _b = _a, { type: t, base: n = CustomEvent } = _b, s = __objRest(_b, ["type", "base"]);
  return e.dispatchEvent(new n(t, s));
};
var be = (e) => e.replace(/([A-Z])/g, "-$1").toLowerCase();
var De = (e, t, n, s) => s == null || t == Boolean && !s ? e.removeAttribute(n) : e.setAttribute(
  n,
  (t == null ? void 0 : t.name) === z && (t == null ? void 0 : t.serialize) ? t == null ? void 0 : t.serialize(s) : F(s) ? JSON.stringify(s) : t == Boolean ? "" : s
);
var Ce = (e, t) => e == Boolean ? !!pe[t] : e == Number ? Number(t) : e == String ? t : e == Array || e == Object ? JSON.parse(t) : e.name == z ? t : (
  // TODO: If when defining reflect the prop can also be of type string?
  new e(t)
);
var Te = ({ map: e }, t) => {
  try {
    return { value: e(t), error: false };
  } catch (e2) {
    return { value: t, error: true };
  }
};
var Ee = (e, t) => e == null || t == null ? { value: t, error: false } : e != String && t === "" ? { value: void 0, error: false } : e == Object || e == Array || e == Symbol ? {
  value: t,
  error: {}.toString.call(t) !== `[object ${e.name}]`
} : t instanceof e ? {
  value: t,
  error: e == Number && Number.isNaN(t.valueOf())
} : e == String || e == Number || e == Boolean ? {
  value: t,
  error: e == Number ? typeof t != "number" ? true : Number.isNaN(t) : e == String ? typeof t != "string" : typeof t != "boolean"
} : { value: t, error: true };
var ve = 0;
var we = (e) => {
  var _a;
  const t = ((_a = (e == null ? void 0 : e.dataset) || {}) == null ? void 0 : _a.hydrate) || "";
  return t || "c" + ve++;
};
var k = (e, t = HTMLElement) => {
  const n = {}, s = {}, o = "prototype" in t && t.prototype instanceof Element, r = o ? t : "base" in t ? t.base : HTMLElement, { props: a, styles: u } = o ? e : t;
  class f extends r {
    constructor() {
      super(), this._setup(), this._render = () => e(__spreadValues({}, this._props));
      for (const c in s) this[c] = s[c];
    }
    /**
     * @returns {import("core").Sheets[]}
     */
    static get styles() {
      return [super.styles, u];
    }
    async _setup() {
      if (this._props) return;
      this._props = {};
      let c, d;
      this.mounted = new Promise(
        (y) => this.mount = () => {
          y(), c != this.parentNode && (d != c ? this.unmounted.then(this.update) : this.update()), c = this.parentNode;
        }
      ), this.unmounted = new Promise(
        (y) => this.unmount = () => {
          y(), (c != this.parentNode || !this.isConnected) && (i.cleanEffects(true)()(), d = this.parentNode, c = null);
        }
      ), this.symbolId = this.symbolId || Symbol(), this.symbolIdParent = Symbol();
      const i = de(
        () => this.update(),
        this,
        we(this)
      );
      let m, g = true;
      const b = ot(this);
      this.update = () => (m || (m = true, this.updated = (this.updated || this.mounted).then(() => {
        try {
          const y = i.load(this._render), p = i.cleanEffects();
          return y && //@ts-ignore
          y.render(this, this.symbolId, b), m = false, g && !i.isSuspense() && (g = false, !b && Se(this)), p();
        } finally {
          m = false;
        }
      }).then(
        /**
         * @param {import("internal/hooks.js").CleanUseEffects} [cleanUseEffect]
         */
        (y) => {
          y && y();
        }
      )), this.updated), this.update();
    }
    connectedCallback() {
      this.mount(), super.connectedCallback && super.connectedCallback();
    }
    disconnectedCallback() {
      super.disconnectedCallback && super.disconnectedCallback(), this.unmount();
    }
    /**
     * @this {import("dom").AtomicoThisInternal}
     * @param {string} attr
     * @param {(string|null)} oldValue
     * @param {(string|null)} value
     */
    attributeChangedCallback(c, d, i) {
      if (n[c]) {
        if (c === this._ignoreAttr || d === i) return;
        const { prop: m, type: g } = n[c];
        try {
          this[m] = Ce(g, i);
        } catch (e2) {
          throw new me(
            this,
            `The value defined as attr '${c}' cannot be parsed by type '${g.name}'`,
            i
          );
        }
      } else
        super.attributeChangedCallback(c, d, i);
    }
    static get props() {
      return __spreadValues(__spreadValues({}, super.props), a);
    }
    static get observedAttributes() {
      const c = super.observedAttributes || [];
      for (const d in a)
        ge(this.prototype, d, a[d], n, s);
      return Object.keys(n).concat(c);
    }
  }
  return f;
};
function Se(e) {
  const { styles: t } = e.constructor, { shadowRoot: n } = e;
  if (n && t.length) {
    const s = [];
    _t2(t, (o) => {
      o && (o instanceof Element ? n.appendChild(o.cloneNode(true)) : s.push(o));
    }), s.length && (n.adoptedStyleSheets = s);
  }
}
var Ht = (e) => (t, n) => {
  R(
    /**
     * Clean the effect hook
     * @type {import("internal/hooks.js").CollectorEffect}
     */
    ([s, o] = []) => ((o || !o) && (o && xt(o, n) ? s = s || true : (M(s) && s(), s = null)), [s, n]),
    /**
     * @returns {any}
     */
    ([s, o], r) => r ? (M(s) && s(), []) : [s || t(), o],
    e
  );
};
var L = Ht(Yt);
var Me = Ht(Ft);
var Wt = class extends Array {
  /**
   *
   * @param {any} initialState
   * @param {(nextState: any, state:any[], mount: boolean )=>void} mapState
   */
  constructor(t, n) {
    let s = true;
    const o = (r) => {
      try {
        n(r, this, s);
      } finally {
        s = false;
      }
    };
    super(void 0, o, n), o(t);
  }
  /**
   * The following code allows a mutable approach to useState
   * and useProp this with the idea of allowing an alternative
   * approach similar to Vue or Qwik of state management
   * @todo pending review with the community
   */
  // get value() {
  //     return this[0];
  // }
  // set value(nextState) {
  //     this[2](nextState, this);
  // }
};
var it = (e) => {
  const t = Lt();
  return R(
    (n = new Wt(e, (s, o, r) => {
      s = M(s) ? s(o[0]) : s, s !== o[0] && (o[0] = s, r || t());
    })) => n
  );
};
var w = (e, t) => {
  const [n] = R(([s, o, r = 0] = []) => ((!o || o && !xt(o, t)) && (s = e()), [s, t, r]));
  return n;
};
var lt = (e) => {
  const { current: t } = W();
  if (!(e in t))
    throw new qt(
      t,
      `For useProp("${e}"), the prop does not exist on the host.`,
      e
    );
  return R(
    (n = new Wt(t[e], (s, o) => {
      s = M(s) ? s(t[e]) : s, t[e] = s;
    })) => (n[0] = t[e], n)
  );
};
var N = (e, t = {}) => {
  const n = W();
  return n[e] || (n[e] = (s = t.detail) => zt(n.current, __spreadProps(__spreadValues({
    type: e
  }, t), {
    detail: s
  }))), n[e];
};
var rt = x("atomico/options");
globalThis[rt] = globalThis[rt] || {
  sheet: !!document.adoptedStyleSheets
};
var K = globalThis[rt];
var Ne = new Promise((e) => {
  K.ssr || (document.readyState === "loading" ? jt(document, "DOMContentLoaded", e) : e());
});
var Pe = {
  checked: 1,
  value: 1,
  selected: 1
};
var ke = {
  list: 1,
  type: 1,
  size: 1,
  form: 1,
  width: 1,
  height: 1,
  src: 1,
  href: 1,
  slot: 1
};
var Oe = {
  shadowDom: 1,
  staticNode: 1,
  cloneNode: 1,
  children: 1,
  key: 1
};
var q = {};
var at = [];
var ct = class extends Text {
};
var Ae = x("atomico/id");
var I = x("atomico/type");
var Q = x("atomico/ref");
var Kt = x("atomico/vnode");
var Jt = () => {
};
function Ue(e, t, n) {
  return Xt(this, e, t, n);
}
var Zt = (e, t, ...n) => {
  const s = t || q;
  let { children: o } = s;
  if (o = o != null ? o : n.length ? n : at, e === Jt)
    return o;
  const r = e ? e instanceof Node ? 1 : (
    //@ts-ignore
    e.prototype instanceof HTMLElement && 2
  ) : 0;
  if (r === false && e instanceof Function)
    return e(
      o != at ? __spreadValues({ children: o }, s) : s
    );
  const a = K.render || Ue;
  return {
    [I]: Kt,
    type: e,
    props: s,
    children: o,
    key: s.key,
    // key for lists by keys
    // define if the node declares its shadowDom
    shadow: s.shadowDom,
    // allows renderings to run only once
    static: s.staticNode,
    // defines whether the type is a childNode `1` or a constructor `2`
    raw: r,
    // defines whether to use the second parameter for document.createElement
    is: s.is,
    // clone the node if it comes from a reference
    clone: s.cloneNode,
    render: a
  };
};
function Xt(e, t, n = Ae, s, o) {
  let r;
  if (t && t[n] && t[n].vnode == e || e[I] != Kt)
    return t;
  (e || !t) && (o = o || e.type == "svg", r = e.type != "host" && (e.raw == 1 ? (t && e.clone ? t[Q] : t) != e.type : e.raw == 2 ? !(t instanceof e.type) : t ? t[Q] || t.localName != e.type : !t), r && e.type != null && (e.raw == 1 && e.clone ? (s = true, t = e.type.cloneNode(true), t[Q] = e.type) : t = e.raw == 1 ? e.type : e.raw == 2 ? new e.type() : o ? document.createElementNS(
    "http://www.w3.org/2000/svg",
    e.type
  ) : document.createElement(
    e.type,
    e.is ? { is: e.is } : void 0
  )));
  const a = t[n] ? t[n] : q, { vnode: u = q, cycle: f = 0 } = a;
  let { fragment: l, handlers: c } = a;
  const { children: d = at, props: i = q } = u;
  if (c = r ? {} : c || {}, e.static && !r) return t;
  if (e.shadow && !t.shadowRoot && // @ts-ignore
  t.attachShadow(__spreadValues({ mode: "open" }, e.shadow)), e.props != i && Ye(t, i, e.props, c, o), e.children !== d) {
    const m = e.shadow ? t.shadowRoot : t;
    l = Re(
      e.children,
      /**
       * @todo for hydration use attribute and send childNodes
       */
      l,
      m,
      n,
      // add support to foreignObject, children will escape from svg
      !f && s,
      o && e.type == "foreignObject" ? false : o
    );
  }
  return t[n] = { vnode: e, handlers: c, fragment: l, cycle: f + 1 }, t;
}
function $e(e, t) {
  const n = new ct(""), s = new ct("");
  let o;
  if (e[t ? "prepend" : "append"](n), t) {
    let { lastElementChild: r } = e;
    for (; r; ) {
      const { previousElementSibling: a } = r;
      if (ot(r, true) && !ot(a, true)) {
        o = r;
        break;
      }
      r = a;
    }
  }
  return o ? o.before(s) : e.append(s), {
    markStart: n,
    markEnd: s
  };
}
function Re(e, t, n, s, o, r) {
  e = e == null ? null : he(e) ? e : [e];
  const a = t || $e(n, o), { markStart: u, markEnd: f, keyes: l } = a;
  let c;
  const d = l && /* @__PURE__ */ new Set();
  let i = u;
  if (e && _t2(e, (m) => {
    if (typeof m == "object" && !m[I])
      return;
    const g = m[I] && m.key, b = l && g != null && l.get(g);
    i != f && i === b ? d.delete(i) : i = i == f ? f : i.nextSibling;
    const y = l ? b : i;
    let p = y;
    if (m[I])
      p = Xt(m, y, s, o, r);
    else {
      const v = m + "";
      !(p instanceof Text) || p instanceof ct ? p = new Text(v) : p.data != v && (p.data = v);
    }
    p != i && (l && d.delete(p), !y || l ? (n.insertBefore(p, i), l && i != f && d.add(i)) : y == f ? n.insertBefore(p, f) : (n.replaceChild(p, y), i = p)), g != null && (c = c || /* @__PURE__ */ new Map(), c.set(g, p));
  }), i = i == f ? f : i.nextSibling, t && i != f)
    for (; i != f; ) {
      const m = i;
      i = i.nextSibling, m.remove();
    }
  return d && d.forEach((m) => m.remove()), a.keyes = c, a;
}
function Ye(e, t, n, s, o) {
  for (const r in t)
    !(r in n) && St(e, r, t[r], null, o, s);
  for (const r in n)
    St(e, r, t[r], n[r], o, s);
}
function St(e, t, n, s, o, r) {
  if (t = t == "class" && !o ? "className" : t, n = n != null ? n : null, s = s != null ? s : null, t in e && Pe[t] && (n = e[t]), !(s === n || Oe[t] || t[0] == "_"))
    if (e.localName === "slot" && t === "assignNode" && "assign" in e)
      e.assign(s);
    else if (t[0] == "o" && t[1] == "n" && (M(s) || M(n)))
      Fe(e, t.slice(2), s, r);
    else if (t == "ref")
      s && (M(s) ? s(e) : s.current = e);
    else if (t == "style") {
      const { style: a } = e;
      n = n || "", s = s || "";
      const u = F(n), f = F(s);
      if (u)
        for (const l in n)
          if (f)
            !(l in s) && Mt(a, l, null);
          else
            break;
      if (f)
        for (const l in s) {
          const c = s[l];
          u && n[l] === c || Mt(a, l, c);
        }
      else
        a.cssText = s;
    } else {
      const a = t[0] == "$" ? t.slice(1) : t;
      a === t && (!o && !ke[t] && t in e || M(s) || M(n)) ? e[t] = s != null ? s : "" : s == null ? e.removeAttribute(a) : e.setAttribute(
        a,
        F(s) ? JSON.stringify(s) : s
      );
    }
}
function Fe(e, t, n, s) {
  if (s.handleEvent || (s.handleEvent = (o) => s[o.type].call(e, o)), n) {
    if (!s[t]) {
      const o = n.capture || n.once || n.passive ? Object.assign({}, n) : null;
      e.addEventListener(t, s, o);
    }
    s[t] = n;
  } else
    s[t] && (e.removeEventListener(t, s), delete s[t]);
}
function Mt(e, t, n) {
  let s = "setProperty";
  n == null && (s = "removeProperty", n = null), ~t.indexOf("-") ? e[s](t, n) : e[t] = n;
}
var Ie = Zt("host", { style: "display: contents" });
var Gt = "value";
var Le = (e, t) => {
  const n = W(), s = It();
  Me(
    () => jt(
      n.current,
      "ConnectContext",
      /**
       * @param {CustomEvent<import("context").DetailConnectContext>} event
       */
      (o) => {
        o.composedPath().at(0) !== o.currentTarget && e === o.detail.id && (o.stopPropagation(), o.detail.connect(s));
      }
    ),
    [e]
  ), s.current = t;
};
var ut = (e) => {
  const t = N("ConnectContext", {
    bubbles: true,
    composed: true
  }), [n, s] = it(() => {
    if (K.ssr) return;
    let r;
    return t({
      id: e,
      /**
       * @param {import("core").Ref} parentContext
       */
      connect(a) {
        r = a;
      }
    }), r;
  }), o = Lt();
  return L(() => {
    Ne.then(
      () => t({
        id: e,
        connect: s
      })
    );
  }, [e]), L(() => {
    if (n)
      return n.on(o);
  }, [n]), (n == null ? void 0 : n.current) || e[Gt];
};
var Qt = (e) => {
  const t = k(
    ({ value: n }) => (Le(t, n), Ie),
    {
      props: {
        value: {
          type: Object,
          value: () => e
        }
      }
    }
  );
  return t[Gt] = e, t;
};
Qt({
  /**
   *
   * @param {string} type
   * @param {string} id
   */
  dispatch(e, t) {
  }
});
var Nt = {};
function J(e, ...t) {
  const n = (e.raw || e).reduce(
    (s, o, r) => s + o + (t[r] || ""),
    ""
  );
  return Nt[n] = Nt[n] || xe(n);
}
function xe(e) {
  if (K.sheet) {
    const t = new CSSStyleSheet();
    return t.replaceSync(e), t;
  } else {
    const t = document.createElement("style");
    return t.textContent = e, t;
  }
}
var h = (e, t, n) => (t == null ? t = { key: n } : t.key = n, Zt(e, t));
var S = h;
var ft = J`*,*:before,*:after{box-sizing:border-box}button{padding:0;touch-action:manipulation;cursor:pointer;user-select:none}`;
var dt = J`.vh{position:absolute;transform:scale(0)}`;
function ht() {
  const e = /* @__PURE__ */ new Date();
  return new C(e.getFullYear(), e.getMonth() + 1, e.getDate());
}
var _e2 = 864e5;
function je(e) {
  const t = E(e);
  t.setUTCDate(t.getUTCDate() + 3 - (t.getUTCDay() + 6) % 7);
  const n = new Date(Date.UTC(t.getUTCFullYear(), 0, 4));
  return 1 + Math.round(
    ((t.getTime() - n.getTime()) / _e2 - 3 + (n.getUTCDay() + 6) % 7) / 7
  );
}
function mt(e, t = 0) {
  const n = E(e), s = n.getUTCDay(), o = (s < t ? 7 : 0) + s - t;
  return n.setUTCDate(n.getUTCDate() - o), C.from(n);
}
function Vt(e, t = 0) {
  return mt(e, t).add({ days: 6 });
}
function te(e) {
  return C.from(new Date(Date.UTC(e.year, e.month, 0)));
}
function Z(e, t, n) {
  return t && C.compare(e, t) < 0 ? t : n && C.compare(e, n) > 0 ? n : e;
}
var Be = { days: 1 };
function qe(e, t = 0) {
  let n = mt(e.toPlainDate(), t);
  const s = Vt(te(e), t), o = [];
  for (; C.compare(n, s) < 0; ) {
    const r = [];
    for (let a = 0; a < 7; a++)
      r.push(n), n = n.add(Be);
    o.push(r);
  }
  return o;
}
function E(e) {
  var _a;
  return new Date(Date.UTC(e.year, e.month - 1, (_a = e.day) != null ? _a : 1));
}
var ze = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[0-1])$/;
var V = (e, t) => e.toString().padStart(t, "0");
var C = class _C {
  constructor(t, n, s) {
    this.year = t, this.month = n, this.day = s;
  }
  // this is an incomplete implementation that only handles arithmetic on a single unit at a time.
  // i didn't want to get into more complex arithmetic since it get tricky fast
  // this is enough to serve my needs and will still be a drop-in replacement when actual Temporal API lands
  add(t) {
    const n = E(this);
    if ("days" in t)
      return n.setUTCDate(this.day + t.days), _C.from(n);
    let { year: s, month: o } = this;
    "months" in t ? (o = this.month + t.months, n.setUTCMonth(o - 1)) : (s = this.year + t.years, n.setUTCFullYear(s));
    const r = _C.from(E({ year: s, month: o, day: 1 }));
    return Z(_C.from(n), r, te(r));
  }
  toString() {
    return `${V(this.year, 4)}-${V(this.month, 2)}-${V(this.day, 2)}`;
  }
  toPlainYearMonth() {
    return new U(this.year, this.month);
  }
  equals(t) {
    return _C.compare(this, t) === 0;
  }
  static compare(t, n) {
    return t.year < n.year ? -1 : t.year > n.year ? 1 : t.month < n.month ? -1 : t.month > n.month ? 1 : t.day < n.day ? -1 : t.day > n.day ? 1 : 0;
  }
  static from(t) {
    if (typeof t == "string") {
      const n = t.match(ze);
      if (!n)
        throw new TypeError(t);
      const [, s, o, r] = n;
      return new _C(
        parseInt(s, 10),
        parseInt(o, 10),
        parseInt(r, 10)
      );
    }
    return new _C(
      t.getUTCFullYear(),
      t.getUTCMonth() + 1,
      t.getUTCDate()
    );
  }
};
var U = class _U {
  constructor(t, n) {
    this.year = t, this.month = n;
  }
  add(t) {
    var _a, _b;
    const n = E(this), s = ((_a = t.months) != null ? _a : 0) + ((_b = t.years) != null ? _b : 0) * 12;
    return n.setUTCMonth(n.getUTCMonth() + s), new _U(n.getUTCFullYear(), n.getUTCMonth() + 1);
  }
  equals(t) {
    return this.year === t.year && this.month === t.month;
  }
  toPlainDate() {
    return new C(this.year, this.month, 1);
  }
  static compare(t, n) {
    return t.year < n.year ? -1 : t.year > n.year ? 1 : t.month < n.month ? -1 : t.month > n.month ? 1 : 0;
  }
};
function H(e, t) {
  if (t)
    try {
      return e.from(t);
    } catch (e2) {
    }
}
function P(e) {
  const [t, n] = lt(e);
  return [w(() => H(C, t), [t]), (r) => n(r == null ? void 0 : r.toString())];
}
function He(e) {
  const [t = "", n] = lt(e);
  return [w(() => {
    const [r, a] = t.split("/"), u = H(C, r), f = H(C, a);
    return u && f ? [u, f] : [];
  }, [t]), (r) => n(`${r[0]}/${r[1]}`)];
}
function We(e) {
  const [t = "", n] = lt(e);
  return [w(() => {
    const r = [];
    for (const a of t.trim().split(/\s+/)) {
      const u = H(C, a);
      u && r.push(u);
    }
    return r;
  }, [t]), (r) => n(r.join(" "))];
}
function $(e, t) {
  return w(
    () => new Intl.DateTimeFormat(t, __spreadValues({ timeZone: "UTC" }, e)),
    [t, e]
  );
}
function Pt(e, t, n) {
  const s = $(e, n);
  return w(() => {
    const o = [], r = /* @__PURE__ */ new Date();
    for (var a = 0; a < 7; a++) {
      const u = (r.getUTCDay() - t + 7) % 7;
      o[u] = s.format(r), r.setUTCDate(r.getUTCDate() + 1);
    }
    return o;
  }, [t, s]);
}
var kt = (e, t, n) => Z(e, t, n) === e;
var Ot = (e) => e.target.matches(":dir(ltr)");
var Ke = { month: "long", day: "numeric" };
var Je = { month: "long" };
var Ze = { weekday: "long" };
var tt = { bubbles: true };
function Xe({ props: e, context: t }) {
  const { offset: n } = e, {
    firstDayOfWeek: s,
    isDateDisallowed: o,
    min: r,
    max: a,
    today: u,
    page: f,
    locale: l,
    focusedDate: c,
    formatWeekday: d
  } = t, i = u != null ? u : ht(), m = Pt(Ze, s, l), g = w(
    () => ({ weekday: d }),
    [d]
  ), b = Pt(g, s, l), y = $(Ke, l), p = $(Je, l), v = w(
    () => f.start.add({ months: n }),
    [f, n]
  ), X = w(
    () => qe(v, s),
    [v, s]
  ), se = N("focusday", tt), oe = N("selectday", tt), re = N("hoverday", tt);
  function Dt(D) {
    se(Z(D, r, a));
  }
  function ae(D) {
    let T;
    switch (D.key) {
      case "ArrowRight":
        T = c.add({ days: Ot(D) ? 1 : -1 });
        break;
      case "ArrowLeft":
        T = c.add({ days: Ot(D) ? -1 : 1 });
        break;
      case "ArrowDown":
        T = c.add({ days: 7 });
        break;
      case "ArrowUp":
        T = c.add({ days: -7 });
        break;
      case "PageUp":
        T = c.add(D.shiftKey ? { years: -1 } : { months: -1 });
        break;
      case "PageDown":
        T = c.add(D.shiftKey ? { years: 1 } : { months: 1 });
        break;
      case "Home":
        T = mt(c, s);
        break;
      case "End":
        T = Vt(c, s);
        break;
      default:
        return;
    }
    Dt(T), D.preventDefault();
  }
  function ce(D) {
    var _a, _b, _c;
    const T = v.equals(D);
    if (!t.showOutsideDays && !T)
      return;
    const ie = D.equals(c), Ct = D.equals(i), j = E(D), B = o == null ? void 0 : o(j), Tt = !kt(D, r, a);
    let Et = "", O;
    if (t.type === "range") {
      const [Y, G] = t.value, vt = Y == null ? void 0 : Y.equals(D), wt = G == null ? void 0 : G.equals(D);
      O = Y && G && kt(D, Y, G), Et = `${vt ? "range-start" : ""} ${wt ? "range-end" : ""} ${O && !vt && !wt ? "range-inner" : ""}`;
    } else t.type === "multi" ? O = t.value.some((Y) => Y.equals(D)) : O = (_a = t.value) == null ? void 0 : _a.equals(D);
    return {
      part: `${`button day day-${j.getUTCDay()} ${// we don't want outside days to ever be shown as selected
      T ? O ? "selected" : "" : "outside"} ${B ? "disallowed" : ""} ${Ct ? "today" : ""} ${(_c = (_b = t.getDayParts) == null ? void 0 : _b.call(t, j)) != null ? _c : ""}`} ${Et}`,
      tabindex: T && ie ? 0 : -1,
      disabled: Tt,
      "aria-disabled": B ? "true" : void 0,
      "aria-pressed": T && O,
      "aria-current": Ct ? "date" : void 0,
      "aria-label": y.format(j),
      onkeydown: ae,
      onclick() {
        B || oe(D), Dt(D);
      },
      onmouseover() {
        !B && !Tt && re(D);
      }
    };
  }
  return {
    weeks: X,
    yearMonth: v,
    daysLong: m,
    daysVisible: b,
    formatter: p,
    getDayProps: ce
  };
}
var et = ht();
var _ = Qt({
  type: "date",
  firstDayOfWeek: 1,
  focusedDate: et,
  page: { start: et.toPlainYearMonth(), end: et.toPlainYearMonth() }
});
customElements.define("calendar-ctx", _);
var Ge = (e, t) => (t + e) % 7;
var Qe = k(
  (e) => {
    const t = ut(_), n = It(), s = Xe({ props: e, context: t });
    function o() {
      var _a;
      (_a = n.current.querySelector("button[tabindex='0']")) == null ? void 0 : _a.focus();
    }
    return /* @__PURE__ */ S("host", { shadowDom: true, focus: o, children: [
      /* @__PURE__ */ h("div", { id: "h", part: "heading", children: s.formatter.format(E(s.yearMonth)) }),
      /* @__PURE__ */ S("table", { ref: n, "aria-labelledby": "h", part: "table", children: [
        /* @__PURE__ */ S("colgroup", { children: [
          t.showWeekNumbers && /* @__PURE__ */ h("col", { part: "col-weeknumber" }),
          /* @__PURE__ */ h("col", { part: "col-1" }),
          /* @__PURE__ */ h("col", { part: "col-2" }),
          /* @__PURE__ */ h("col", { part: "col-3" }),
          /* @__PURE__ */ h("col", { part: "col-4" }),
          /* @__PURE__ */ h("col", { part: "col-5" }),
          /* @__PURE__ */ h("col", { part: "col-6" }),
          /* @__PURE__ */ h("col", { part: "col-7" })
        ] }),
        /* @__PURE__ */ h("thead", { children: /* @__PURE__ */ S("tr", { part: "tr head", children: [
          t.showWeekNumbers && /* @__PURE__ */ h("th", { part: "th weeknumber", children: /* @__PURE__ */ S("slot", { name: "weeknumber", children: [
            /* @__PURE__ */ h("span", { class: "vh", children: "Week" }),
            /* @__PURE__ */ h("span", { "aria-hidden": "true", children: "#" })
          ] }) }),
          s.daysLong.map((r, a) => /* @__PURE__ */ S(
            "th",
            {
              part: `th day day-${Ge(t.firstDayOfWeek, a)}`,
              scope: "col",
              children: [
                /* @__PURE__ */ h("span", { class: "vh", children: r }),
                /* @__PURE__ */ h("span", { "aria-hidden": "true", children: s.daysVisible[a] })
              ]
            }
          ))
        ] }) }),
        /* @__PURE__ */ h("tbody", { children: s.weeks.map((r, a) => /* @__PURE__ */ S("tr", { part: "tr week", children: [
          t.showWeekNumbers && /* @__PURE__ */ h("th", { class: "num", part: "th weeknumber", scope: "row", children: je(r[0]) }),
          r.map((u, f) => {
            const l = s.getDayProps(u);
            return /* @__PURE__ */ h("td", { part: "td", children: l && /* @__PURE__ */ h("button", __spreadProps(__spreadValues({ class: "num" }, l), { children: u.day })) }, f);
          })
        ] }, a)) })
      ] })
    ] });
  },
  {
    props: {
      offset: {
        type: Number,
        value: 0
      }
    },
    styles: [
      ft,
      dt,
      J`:host{--color-accent: black;--color-text-on-accent: white;display:flex;flex-direction:column;gap:.25rem;text-align:center;inline-size:fit-content}table{border-collapse:collapse;font-size:.875rem}th{inline-size:2.25rem;block-size:2.25rem}td{padding-inline:0}.num{font-variant-numeric:tabular-nums}button{color:inherit;font-size:inherit;background:transparent;border:0;block-size:2.25rem;inline-size:2.25rem}button:hover:where(:not(:disabled,[aria-disabled])){background:#0000000d}button:is([aria-pressed=true],:focus-visible){background:var(--color-accent);color:var(--color-text-on-accent)}button:focus-visible{outline:1px solid var(--color-text-on-accent);outline-offset:-2px}button:disabled,:host::part(outside),:host::part(disallowed){cursor:default;opacity:.5}`
    ]
  }
);
customElements.define("calendar-month", Qe);
function At(e) {
  return /* @__PURE__ */ h(
    "button",
    {
      part: `button ${e.name} ${e.onclick ? "" : "disabled"}`,
      onclick: e.onclick,
      "aria-disabled": e.onclick ? null : "true",
      children: /* @__PURE__ */ h("slot", { name: e.name, children: e.children })
    }
  );
}
function yt(e) {
  const t = E(e.page.start), n = E(e.page.end);
  return /* @__PURE__ */ h(
    _,
    {
      value: e,
      onselectday: e.onSelect,
      onfocusday: e.onFocus,
      onhoverday: e.onHover,
      children: /* @__PURE__ */ S("div", { role: "group", "aria-labelledby": "h", part: "container", children: [
        /* @__PURE__ */ h("div", { id: "h", class: "vh", "aria-live": "polite", "aria-atomic": "true", children: e.formatVerbose.formatRange(t, n) }),
        /* @__PURE__ */ S("div", { part: "header", children: [
          /* @__PURE__ */ h(At, { name: "previous", onclick: e.previous, children: "Previous" }),
          /* @__PURE__ */ h("slot", { part: "heading", name: "heading", children: /* @__PURE__ */ h("div", { "aria-hidden": "true", children: e.format.formatRange(t, n) }) }),
          /* @__PURE__ */ h(At, { name: "next", onclick: e.next, children: "Next" })
        ] }),
        /* @__PURE__ */ h("slot", { part: "months" })
      ] })
    }
  );
}
var pt = {
  value: {
    type: String,
    value: ""
  },
  min: {
    type: String,
    value: ""
  },
  max: {
    type: String,
    value: ""
  },
  today: {
    type: String,
    value: ""
  },
  isDateDisallowed: {
    type: Function,
    value: (e) => false
  },
  formatWeekday: {
    type: String,
    value: () => "narrow"
  },
  getDayParts: {
    type: Function,
    value: (e) => ""
  },
  firstDayOfWeek: {
    type: Number,
    value: () => 1
  },
  showOutsideDays: {
    type: Boolean,
    value: false
  },
  locale: {
    type: String,
    value: () => {
    }
  },
  months: {
    type: Number,
    value: 1
  },
  focusedDate: {
    type: String,
    value: () => {
    }
  },
  pageBy: {
    type: String,
    value: () => "months"
  },
  showWeekNumbers: {
    type: Boolean,
    value: false
  }
};
var gt = [
  ft,
  dt,
  J`:host{display:block;inline-size:fit-content}:host::part(container){display:flex;flex-direction:column;gap:1em}:host::part(header){display:flex;align-items:center;justify-content:space-between}:host::part(heading){font-weight:700;font-size:1.25em}:host::part(button){display:flex;align-items:center;justify-content:center}:host::part(button disabled){cursor:default;opacity:.5}`
];
var Ve = { year: "numeric" };
var tn = { year: "numeric", month: "long" };
function nt(e, t) {
  return (t.year - e.year) * 12 + t.month - e.month;
}
var Ut = (e, t) => (e = t === 12 ? new U(e.year, 1) : e, {
  start: e,
  end: e.add({ months: t - 1 })
});
function en({
  pageBy: e,
  focusedDate: t,
  months: n,
  max: s,
  min: o,
  goto: r
}) {
  const a = e === "single" ? 1 : n, [u, f] = it(
    () => Ut(t.toPlainYearMonth(), n)
  ), l = (d) => f(Ut(u.start.add({ months: d }), n)), c = (d) => {
    const i = nt(u.start, d.toPlainYearMonth());
    return i >= 0 && i < n;
  };
  return L(() => {
    if (c(t))
      return;
    const d = nt(t.toPlainYearMonth(), u.start);
    r(t.add({ months: d }));
  }, [u.start]), L(() => {
    if (c(t))
      return;
    const d = nt(u.start, t.toPlainYearMonth());
    l(d === -1 ? -a : d === n ? a : Math.floor(d / n) * n);
  }, [t, a, n]), {
    page: u,
    previous: !o || !c(o) ? () => l(-a) : void 0,
    next: !s || !c(s) ? () => l(a) : void 0
  };
}
function bt({
  months: e,
  pageBy: t,
  locale: n,
  focusedDate: s,
  setFocusedDate: o
}) {
  const [r] = P("min"), [a] = P("max"), [u] = P("today"), f = N("focusday"), l = N("change"), c = w(
    () => {
      var _a;
      return Z((_a = s != null ? s : u) != null ? _a : ht(), r, a);
    },
    [s, u, r, a]
  );
  function d(p) {
    o(p), f(E(p));
  }
  const { next: i, previous: m, page: g } = en({
    pageBy: t,
    focusedDate: c,
    months: e,
    min: r,
    max: a,
    goto: d
  }), b = W();
  function y(p) {
    var _a;
    const v = (_a = p == null ? void 0 : p.target) != null ? _a : "day";
    v === "day" ? b.current.querySelectorAll("calendar-month").forEach((X) => X.focus(p)) : b.current.shadowRoot.querySelector(`[part~='${v}']`).focus(p);
  }
  return {
    format: $(Ve, n),
    formatVerbose: $(tn, n),
    page: g,
    focusedDate: c,
    dispatch: l,
    onFocus(p) {
      p.stopPropagation(), d(p.detail), setTimeout(y);
    },
    min: r,
    max: a,
    today: u,
    next: i,
    previous: m,
    focus: y
  };
}
var nn = k(
  (e) => {
    const [t, n] = P("value"), [s = t, o] = P("focusedDate"), r = bt(__spreadProps(__spreadValues({}, e), {
      focusedDate: s,
      setFocusedDate: o
    }));
    function a(u) {
      n(u.detail), r.dispatch();
    }
    return /* @__PURE__ */ h("host", { shadowDom: true, focus: r.focus, children: /* @__PURE__ */ h(
      yt,
      __spreadProps(__spreadValues(__spreadValues({}, e), r), {
        type: "date",
        value: t,
        onSelect: a
      })
    ) });
  },
  { props: pt, styles: gt }
);
customElements.define("calendar-date", nn);
function ee(e) {
  return /* @__PURE__ */ S(Jt, { children: [
    /* @__PURE__ */ h("label", { part: "label", for: "s", children: /* @__PURE__ */ h("slot", { name: "label", children: e.label }) }),
    /* @__PURE__ */ h("select", { id: "s", part: "select", onchange: e.onChange, children: e.options.map((t) => /* @__PURE__ */ h("option", __spreadValues({ part: "option" }, t))) })
  ] });
}
var ne = [ft, dt];
function sn(e, t) {
  return Array.from({ length: e }, (n, s) => t(s));
}
function on(e) {
  var _a, _b;
  const { min: t, max: n, focusedDate: s } = ut(_), o = N("focusday", { bubbles: true }), r = s.toPlainYearMonth(), a = r.year, u = Math.floor(e.maxYears / 2), f = a - u, l = a + (e.maxYears - u - 1), c = Math.max(f, (_a = t == null ? void 0 : t.year) != null ? _a : -1 / 0), d = Math.min(l, (_b = n == null ? void 0 : n.year) != null ? _b : 1 / 0), i = sn(d - c + 1, (g) => {
    const b = c + g;
    return {
      label: `${b}`,
      value: `${b}`,
      selected: b === r.year
    };
  });
  function m(g) {
    const y = parseInt(g.currentTarget.value) - r.year;
    o(s.add({ years: y }));
  }
  return { options: i, onChange: m };
}
var rn = k(
  (e) => {
    const t = on(e);
    return /* @__PURE__ */ h("host", { shadowDom: true, children: /* @__PURE__ */ h(ee, __spreadValues({ label: "Year" }, t)) });
  },
  {
    props: {
      maxYears: { type: Number, value: 20 }
    },
    styles: ne
  }
);
customElements.define("calendar-select-year", rn);
function an(e) {
  const { min: t, max: n, focusedDate: s, locale: o } = ut(_), r = N("focusday", { bubbles: true }), a = w(
    () => ({ month: e.formatMonth }),
    [e.formatMonth]
  ), u = $(a, o), f = w(() => {
    const i = [], m = /* @__PURE__ */ new Date();
    m.setUTCDate(1);
    for (var g = 0; g < 12; g++) {
      const b = (m.getUTCMonth() + 12) % 12;
      i[b] = u.format(m), m.setUTCMonth(m.getUTCMonth() + 1);
    }
    return i;
  }, [u]), l = s.toPlainYearMonth(), c = f.map((i, m) => {
    const g = m + 1, b = l.add({ months: g - l.month }), y = t != null && U.compare(b, t) < 0 || n != null && U.compare(b, n) > 0;
    return {
      label: i,
      value: `${g}`,
      disabled: y,
      selected: g === l.month
    };
  });
  function d(i) {
    const g = parseInt(i.currentTarget.value) - l.month;
    r(s.add({ months: g }));
  }
  return { options: c, onChange: d };
}
var cn = k(
  (e) => {
    const t = an(e);
    return /* @__PURE__ */ h("host", { shadowDom: true, children: /* @__PURE__ */ h(ee, __spreadValues({ label: "Month" }, t)) });
  },
  {
    props: {
      formatMonth: {
        type: String,
        value: () => "long"
      }
    },
    styles: ne
  }
);
customElements.define("calendar-select-month", cn);
var $t = (e, t) => C.compare(e, t) < 0 ? [e, t] : [t, e];
var ln = k(
  (e) => {
    const [t, n] = He("value"), [s = t[0], o] = P("focusedDate"), r = bt(__spreadProps(__spreadValues({}, e), {
      focusedDate: s,
      setFocusedDate: o
    })), a = N("rangestart"), u = N("rangeend"), [f, l] = P(
      "tentative"
    ), [c, d] = it();
    L(() => d(void 0), [f]);
    function i(y) {
      r.onFocus(y), m(y);
    }
    function m(y) {
      y.stopPropagation(), f && d(y.detail);
    }
    function g(y) {
      const p = y.detail;
      y.stopPropagation(), f ? (n($t(f, p)), l(void 0), u(E(p)), r.dispatch()) : (l(p), a(E(p)));
    }
    const b = f ? $t(f, c != null ? c : f) : t;
    return /* @__PURE__ */ h("host", { shadowDom: true, focus: r.focus, children: /* @__PURE__ */ h(
      yt,
      __spreadProps(__spreadValues(__spreadValues({}, e), r), {
        type: "range",
        value: b,
        onFocus: i,
        onHover: m,
        onSelect: g
      })
    ) });
  },
  {
    props: __spreadProps(__spreadValues({}, pt), {
      tentative: {
        type: String,
        value: ""
      }
    }),
    styles: gt
  }
);
customElements.define("calendar-range", ln);
var un = k(
  (e) => {
    const [t, n] = We("value"), [s = t[0], o] = P("focusedDate"), r = bt(__spreadProps(__spreadValues({}, e), {
      focusedDate: s,
      setFocusedDate: o
    }));
    function a(u) {
      const f = [...t], l = t.findIndex((c) => c.equals(u.detail));
      l < 0 ? f.push(u.detail) : f.splice(l, 1), n(f), r.dispatch();
    }
    return /* @__PURE__ */ h("host", { shadowDom: true, focus: r.focus, children: /* @__PURE__ */ h(
      yt,
      __spreadProps(__spreadValues(__spreadValues({}, e), r), {
        type: "multi",
        value: t,
        onSelect: a
      })
    ) });
  },
  { props: pt, styles: gt }
);
customElements.define("calendar-multi", un);

// js/hooks/helpers/date_picker.js
var KEYS2 = {
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  TAB: "Tab"
};
var WEEKDAY_LABELS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
var SUPPRESSION_WINDOW_MS = 200;
function createDatePickerHelpers(hook) {
  let suppressNextEvent = false;
  let suppressionTimeout = null;
  const openCalendar = () => {
    executeCommand(hook, hook.el.dataset.showDisclosure);
  };
  const closeCalendar = () => {
    executeCommand(hook, hook.el.dataset.hideDisclosure);
  };
  const handleInputKeydown = (event) => {
    var _a, _b;
    const { key } = event;
    const isCalendarOpen = !((_a = hook.elements.calendarWrapper) == null ? void 0 : _a.hidden);
    const actions = {
      [KEYS2.ENTER]: () => {
        if (!isCalendarOpen) {
          event.preventDefault();
          openCalendar();
        }
      },
      [KEYS2.UP]: () => {
        if (isCalendarOpen) {
          event.preventDefault();
          closeCalendar();
        }
      },
      [KEYS2.DOWN]: () => {
        if (!isCalendarOpen) {
          event.preventDefault();
          openCalendar();
        }
      },
      [KEYS2.ESCAPE]: () => {
        if (isCalendarOpen) {
          event.preventDefault();
          closeCalendar();
        }
      }
    };
    (_b = actions[key]) == null ? void 0 : _b.call(actions);
  };
  const handleContainerKeydown = (event, focusTarget = ((_a) => (_a = hook.elements) == null ? void 0 : _a.input)()) => {
    var _a2, _b;
    const { key } = event;
    const isCalendarOpen = !((_a2 = hook.elements.calendarWrapper) == null ? void 0 : _a2.hidden);
    if (!isCalendarOpen) return;
    const actions = {
      [KEYS2.ESCAPE]: () => {
        event.preventDefault();
        closeCalendar();
        focusTarget == null ? void 0 : focusTarget.focus();
      }
    };
    (_b = actions[key]) == null ? void 0 : _b.call(actions);
  };
  const updateCalendarHeaders = () => {
    hook.elements.calendarMonths.forEach((calendarMonth) => {
      WEEKDAY_LABELS.forEach((label, index2) => {
        var _a;
        const th = (_a = calendarMonth.shadowRoot) == null ? void 0 : _a.querySelector(`thead th[part="th day day-${index2}"] span[aria-hidden="true"]`);
        if (th) {
          th.textContent = label;
        }
      });
    });
  };
  const pushDateEvent = (eventName, event, { suppressNextEvent: suppressNextEvent2 = false, skipWhenSuppressed = false, skipWhenCalendarClosed = false } = {}) => {
    var _a, _b;
    if (skipWhenCalendarClosed && ((_a = hook.elements.calendarWrapper) == null ? void 0 : _a.hidden)) {
      return;
    }
    if (skipWhenSuppressed && shouldSkipEvent()) {
      return;
    }
    if (suppressNextEvent2) {
      suppressNextHandledEvent();
    }
    const date = (_b = event.detail) == null ? void 0 : _b.toISOString().split("T")[0];
    if (!date) {
      return;
    }
    hook.pushEventTo(`#${hook.el.id}`, eventName, { date });
  };
  const suppressNextHandledEvent = () => {
    suppressNextEvent = true;
    if (suppressionTimeout) {
      clearTimeout(suppressionTimeout);
    }
    suppressionTimeout = setTimeout(() => {
      suppressNextEvent = false;
      suppressionTimeout = null;
    }, SUPPRESSION_WINDOW_MS);
  };
  const shouldSkipEvent = () => {
    if (!suppressNextEvent) {
      return false;
    }
    suppressNextEvent = false;
    return true;
  };
  const cleanupSuppressionEvents = () => {
    if (suppressionTimeout) {
      clearTimeout(suppressionTimeout);
    }
    suppressionTimeout = null;
    suppressNextEvent = false;
  };
  return {
    openCalendar,
    closeCalendar,
    updateCalendarHeaders,
    handleInputKeydown,
    handleContainerKeydown,
    pushDateEvent,
    suppressNextEvent: suppressNextHandledEvent,
    shouldSkipEvent,
    cleanupSuppressionEvents
  };
}

// js/hooks/helpers/custom_input.js
function createCustomInputHelpers(hook) {
  const bubbleChangeEvent = (data, hiddenInput = "hiddenInput") => {
    var _a;
    if (hook.el.id !== data.id) {
      return;
    }
    (_a = hook.elements[hiddenInput]) == null ? void 0 : _a.dispatchEvent(new Event("input", { bubbles: true }));
  };
  return {
    bubbleChangeEvent
  };
}

// js/hooks/date_picker.js
var date_picker_default = {
  mounted() {
    var _a, _b, _c, _d, _e3;
    this.abortController = new AbortController();
    this.helpers = createDatePickerHelpers(this);
    this.customInputHelpers = createCustomInputHelpers(this);
    this.elements = {
      input: this.el.querySelector('input[type="text"]'),
      calendarButton: this.el.querySelector("button[aria-controls]"),
      calendarWrapper: this.el.querySelector('[role="dialog"]'),
      calendarDate: this.el.querySelector("calendar-date"),
      hiddenInput: this.el.querySelector('input[type="hidden"]'),
      calendarMonths: this.el.querySelectorAll("calendar-month")
    };
    this.handlers = {
      calendarDateChange: this._handleDateChange.bind(this),
      calendarDateFocusDay: (event) => this.helpers.pushDateEvent("focus_day", event, { skipWhenSuppressed: true, skipWhenCalendarClosed: true }),
      inputKeydown: this.helpers.handleInputKeydown,
      containerKeydown: (event) => this.helpers.handleContainerKeydown(event),
      calendarDateFocus: this._focusCalendarDate.bind(this),
      hiddenInput: this.customInputHelpers.bubbleChangeEvent,
      stopPropagation: (event) => event.stopPropagation()
    };
    (_a = this.elements.input) == null ? void 0 : _a.addEventListener("change", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_b = this.elements.input) == null ? void 0 : _b.addEventListener("input", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_c = this.elements.calendarDate) == null ? void 0 : _c.addEventListener("change", this.handlers.calendarDateChange, {
      signal: this.abortController.signal
    });
    (_d = this.elements.calendarDate) == null ? void 0 : _d.addEventListener("focusday", this.handlers.calendarDateFocusDay, {
      signal: this.abortController.signal
    });
    (_e3 = this.elements.input) == null ? void 0 : _e3.addEventListener("keydown", this.handlers.inputKeydown, {
      signal: this.abortController.signal
    });
    this.el.addEventListener("keydown", this.handlers.containerKeydown, { signal: this.abortController.signal });
    this.handleEvent("date_picker:focus", this.handlers.calendarDateFocus);
    this.handleEvent("date_picker:selected", this.handlers.hiddenInput);
    this.helpers.updateCalendarHeaders();
  },
  updated() {
    this.helpers.updateCalendarHeaders();
  },
  destroyed() {
    var _a, _b;
    (_a = this.helpers) == null ? void 0 : _a.cleanupSuppressionEvents();
    (_b = this.abortController) == null ? void 0 : _b.abort();
  },
  _handleDateChange(event) {
    if (event.target.value) {
      this.helpers.suppressNextEvent();
      this.pushEventTo(`#${this.el.id}`, "select_date", { value: event.target.value });
    }
  },
  _focusCalendarDate(data) {
    var _a;
    if (this.el.id !== data.id) {
      return;
    }
    (_a = this.elements.calendarDate) == null ? void 0 : _a.focus();
  }
};

// js/hooks/date_range_picker.js
var date_range_picker_default = {
  mounted() {
    var _a, _b, _c, _d, _e3, _f, _g, _h, _i;
    this.abortController = new AbortController();
    this.helpers = createDatePickerHelpers(this);
    this.customInputHelpers = createCustomInputHelpers(this);
    this.elements = {
      inputStart: this.el.querySelector('input[data-date-range-start-picker-input="true"]'),
      inputEnd: this.el.querySelector('input[data-date-range-end-picker-input="true"]'),
      calendarWrapper: this.el.querySelector('[role="dialog"]'),
      calendarRange: this.el.querySelector("calendar-range"),
      hiddenInputStart: this.el.querySelector(`input[data-date-range-picker-hidden-start-input="true"]`),
      hiddenInputEnd: this.el.querySelector(`input[data-date-range-picker-hidden-end-input="true"]`),
      calendarMonths: this.el.querySelectorAll("calendar-month")
    };
    this.handlers = {
      calendarRangeStart: (e) => this.helpers.pushDateEvent("select_range_start", e, { suppressNextEvent: true }),
      calendarRangeEnd: (e) => this.helpers.pushDateEvent("select_range_end", e, { suppressNextEvent: true }),
      calendarRangeFocusDay: (e) => this.helpers.pushDateEvent("focus_day", e, { skipWhenSuppressed: true, skipWhenCalendarClosed: true }),
      inputKeydown: this.helpers.handleInputKeydown,
      containerKeydown: (event) => this.helpers.handleContainerKeydown(event, this.elements.inputStart),
      calendarRangeFocus: this._focusCalendarRange.bind(this),
      hiddenInputStart: (data) => this.customInputHelpers.bubbleChangeEvent(data, "hiddenInputStart"),
      hiddenInputEnd: (data) => this.customInputHelpers.bubbleChangeEvent(data, "hiddenInputEnd"),
      stopPropagation: (event) => event.stopPropagation()
    };
    (_a = this.elements.inputStart) == null ? void 0 : _a.addEventListener("change", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_b = this.elements.inputStart) == null ? void 0 : _b.addEventListener("input", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_c = this.elements.inputEnd) == null ? void 0 : _c.addEventListener("change", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_d = this.elements.inputEnd) == null ? void 0 : _d.addEventListener("input", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_e3 = this.elements.calendarRange) == null ? void 0 : _e3.addEventListener("rangestart", this.handlers.calendarRangeStart, {
      signal: this.abortController.signal
    });
    (_f = this.elements.calendarRange) == null ? void 0 : _f.addEventListener("rangeend", this.handlers.calendarRangeEnd, {
      signal: this.abortController.signal
    });
    (_g = this.elements.calendarRange) == null ? void 0 : _g.addEventListener("focusday", this.handlers.calendarRangeFocusDay, {
      signal: this.abortController.signal
    });
    (_h = this.elements.inputStart) == null ? void 0 : _h.addEventListener("keydown", this.handlers.inputKeydown, {
      signal: this.abortController.signal
    });
    (_i = this.elements.inputEnd) == null ? void 0 : _i.addEventListener("keydown", this.handlers.inputKeydown, {
      signal: this.abortController.signal
    });
    this.el.addEventListener("keydown", this.handlers.containerKeydown, {
      signal: this.abortController.signal
    });
    this.handleEvent("date_range_picker:focus", this.handlers.calendarRangeFocus);
    this.handleEvent("date_range_picker:selected-start", this.handlers.hiddenInputStart);
    this.handleEvent("date_range_picker:selected-end", this.handlers.hiddenInputEnd);
    this.helpers.updateCalendarHeaders();
  },
  updated() {
    this.elements.calendarMonths = this.el.querySelectorAll("calendar-month");
    this.helpers.updateCalendarHeaders();
  },
  destroyed() {
    var _a, _b;
    (_a = this.helpers) == null ? void 0 : _a.cleanupSuppressionEvents();
    (_b = this.abortController) == null ? void 0 : _b.abort();
  },
  _focusCalendarRange(data) {
    var _a;
    if (this.el.id !== data.id) {
      return;
    }
    (_a = this.elements.calendarRange) == null ? void 0 : _a.focus();
  }
};

// js/hooks/filter_date_range_picker.js
var filter_date_range_picker_default = {
  mounted() {
    var _a, _b, _c, _d, _e3, _f;
    this.abortController = new AbortController();
    this.helpers = createDatePickerHelpers(this);
    this.customInputHelpers = createCustomInputHelpers(this);
    this.elements = {
      input: this.el.querySelector('input[data-filter-date-range-picker-main-input="true"]'),
      calendarWrapper: this.el.querySelector('[role="dialog"]'),
      calendarRange: this.el.querySelector("calendar-range"),
      hiddenInputStart: this.el.querySelector(`input[data-filter-date-range-picker-hidden-start-input="true"]`),
      hiddenInputEnd: this.el.querySelector(`input[data-filter-date-range-picker-hidden-end-input="true"]`),
      hiddenInputPreset: this.el.querySelector(`input[data-filter-date-range-picker-hidden-preset-input="true"]`),
      calendarMonths: this.el.querySelectorAll("calendar-month")
    };
    this.handlers = {
      rangeStart: (e) => this.helpers.pushDateEvent("select_range_start", e, { suppressNextEvent: true }),
      rangeEnd: (e) => this.helpers.pushDateEvent("select_range_end", e, { suppressNextEvent: true }),
      focusDay: (e) => this.helpers.pushDateEvent("focus_day", e, { skipWhenSuppressed: true, skipWhenCalendarClosed: true }),
      inputKeydown: this.helpers.handleInputKeydown,
      containerKeydown: (event) => this.helpers.handleContainerKeydown(event),
      focusOut: this._handleFocusOut.bind(this),
      hiddenInputStart: (data) => this.customInputHelpers.bubbleChangeEvent(data, "hiddenInputStart"),
      hiddenInputEnd: (data) => this.customInputHelpers.bubbleChangeEvent(data, "hiddenInputEnd"),
      hiddenInputPreset: (data) => this.customInputHelpers.bubbleChangeEvent(data, "hiddenInputPreset"),
      stopPropagation: (event) => event.stopPropagation()
    };
    (_a = this.elements.input) == null ? void 0 : _a.addEventListener("change", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    (_b = this.elements.input) == null ? void 0 : _b.addEventListener("input", this.handlers.stopPropagation, {
      signal: this.abortController.signal
    });
    this.mediaQuery = window.matchMedia("(max-width: 635px)");
    this.isSmallScreen = null;
    this._maybeToggleSmallScreen(this.mediaQuery.matches);
    this.mediaQuery.addEventListener("change", (e) => this._maybeToggleSmallScreen(e.matches), {
      signal: this.abortController.signal
    });
    (_c = this.elements.calendarRange) == null ? void 0 : _c.addEventListener("rangestart", this.handlers.rangeStart, {
      signal: this.abortController.signal
    });
    (_d = this.elements.calendarRange) == null ? void 0 : _d.addEventListener("rangeend", this.handlers.rangeEnd, {
      signal: this.abortController.signal
    });
    (_e3 = this.elements.calendarRange) == null ? void 0 : _e3.addEventListener("focusday", this.handlers.focusDay, {
      signal: this.abortController.signal
    });
    (_f = this.elements.input) == null ? void 0 : _f.addEventListener("keydown", this.handlers.inputKeydown, {
      signal: this.abortController.signal
    });
    this.el.addEventListener("keydown", this.handlers.containerKeydown, {
      signal: this.abortController.signal
    });
    this.el.addEventListener("focusout", this.handlers.focusOut, {
      signal: this.abortController.signal
    });
    this.handleEvent("filter_date_range_picker:selected-start", this.handlers.hiddenInputStart);
    this.handleEvent("filter_date_range_picker:selected-end", this.handlers.hiddenInputEnd);
    this.handleEvent("filter_date_range_picker:selected-preset", this.handlers.hiddenInputPreset);
    this.handleEvent("filter_date_range_picker:input-blur-start", this.handlers.hiddenInputStart);
    this.handleEvent("filter_date_range_picker:input-blur-end", this.handlers.hiddenInputEnd);
    this.handleEvent("filter_date_range_picker:main-input-blur", this.handlers.hiddenInputEnd);
    this.helpers.updateCalendarHeaders();
  },
  updated() {
    this.helpers.updateCalendarHeaders();
  },
  destroyed() {
    var _a, _b;
    (_a = this.helpers) == null ? void 0 : _a.cleanupSuppressionEvents();
    (_b = this.abortController) == null ? void 0 : _b.abort();
  },
  _maybeToggleSmallScreen(isSmall) {
    if (this.isSmallScreen !== isSmall) {
      this.isSmallScreen = isSmall;
      this.pushEventTo(`#${this.el.id}`, "configure_for_small_screen", { enabled: isSmall });
    }
  },
  _handleFocusOut(event) {
    var _a;
    const { relatedTarget } = event;
    if (!relatedTarget || this.el.contains(relatedTarget) || ((_a = this.elements.calendarWrapper) == null ? void 0 : _a.hidden)) {
      return;
    }
    this.helpers.closeCalendar();
  }
};

// js/hooks/dropdown.js
var KEYS3 = {
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  TAB: "Tab",
  HOME: "Home",
  END: "End"
};
var getSibling = (target, direction = "next") => {
  const element = target[direction === "next" ? "nextElementSibling" : "previousElementSibling"];
  if (!element) return null;
  return element.getAttribute("aria-disabled") === "true" ? getSibling(element, direction) : element;
};
var getNextSibling = (target) => getSibling(target, "next");
var getPreviousSibling = (target) => getSibling(target, "previous");
var isListExpanded = (trigger) => trigger.getAttribute("aria-expanded") == "true";
var dropdown_default = {
  mounted() {
    this.customInputHelpers = createCustomInputHelpers(this);
    this.elements = {
      trigger: this.el.querySelector(`[role="combobox"]`),
      listbox: this.el.querySelector(`[role="listbox"]`),
      activeOption: null,
      hiddenInput: this.el.querySelector('input[type="hidden"]')
    };
    this.handlers = {
      container: this._handleMainContainerKeydown.bind(this),
      trigger: this._handleTriggerKeydown.bind(this),
      hiddenInput: this.customInputHelpers.bubbleChangeEvent
    };
    this.el.addEventListener("keydown", this.handlers.container);
    this.elements.trigger.addEventListener("keydown", this.handlers.trigger);
    this.handleEvent("dropdown:selected", this.handlers.hiddenInput);
    this.handleEvent("dropdown:deselect-all", this.handlers.hiddenInput);
    this._expandedObserver = new MutationObserver(() => this._syncPopover());
    this._expandedObserver.observe(this.elements.trigger, {
      attributes: true,
      attributeFilter: ["aria-expanded"]
    });
    this.elements.activeOption = Array.from(this._fetchOptions()).find(
      (option2) => option2.getAttribute("aria-selected") === "true"
    );
    this._setOptionAsActive(this.elements.activeOption);
    this.el.setAttribute("data-ready", "true");
  },
  _syncPopover() {
    const { trigger, listbox } = this.elements;
    listbox == null ? void 0 : listbox.togglePopover(isListExpanded(trigger));
  },
  _handleMainContainerKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS3.SPACE]: () => {
        event.preventDefault();
        this._handleDisclosure("toggle");
      },
      [KEYS3.TAB]: () => this._handleDisclosure("hide"),
      [KEYS3.ESCAPE]: () => {
        event.preventDefault();
        this._handleDisclosure("hide");
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleTriggerKeydown(event) {
    if (isListExpanded(this.elements.trigger) && this._getActiveOption()) {
      this._handleTriggerKeydownWithActiveDescendant(event);
    } else {
      this._handleTriggerKeydownWithNoActiveDescendant(event);
    }
  },
  _handleTriggerKeydownWithNoActiveDescendant(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS3.DOWN]: () => this._focusOption("first"),
      [KEYS3.UP]: () => this._focusOption(isListExpanded(this.elements.trigger) ? "last" : "first")
    };
    if (!actions[key]) return;
    event.preventDefault();
    if (this._handleDisclosure("show")) {
      (_a = actions[key]) == null ? void 0 : _a.call(actions);
    }
  },
  _handleTriggerKeydownWithActiveDescendant(event) {
    var _a;
    const { key } = event;
    const activeOption = this._getActiveOption();
    const actions = {
      [KEYS3.DOWN]: () => this._setOptionAsActive(getNextSibling(activeOption)),
      [KEYS3.UP]: () => this._setOptionAsActive(getPreviousSibling(activeOption)),
      [KEYS3.ENTER]: () => this._activateOption(activeOption),
      [KEYS3.HOME]: () => this._focusOption("first"),
      [KEYS3.END]: () => this._focusOption("last")
    };
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleDisclosure(action) {
    const commandMap = {
      show: "showDisclosure",
      hide: "hideDisclosure",
      toggle: "toggleDisclosure"
    };
    const command = this.el.dataset[commandMap[action]];
    return executeCommand(this, command);
  },
  _fetchOptions() {
    return this.el.querySelectorAll(`[role="option"][aria-disabled="false"]`);
  },
  _focusOption(position) {
    const options = Array.from(this._fetchOptions());
    if (!options.length) return;
    const optionToFocus = position === "last" ? options[options.length - 1] : options[0];
    this._setOptionAsActive(optionToFocus);
  },
  _setOptionAsActive(option2) {
    if (!option2) {
      return;
    }
    this._fetchOptions().forEach((el) => el.classList.remove("active"));
    option2.classList.add("active");
    this.elements.activeOption = option2;
    this.elements.trigger.setAttribute("aria-activedescendant", option2.id);
    const optionCoordinates = option2.getBoundingClientRect();
    const options = Array.from(this._fetchOptions());
    const optionIndex = options.indexOf(option2);
    this.elements.listbox.scrollTo({
      top: optionCoordinates.height * optionIndex,
      left: 0,
      behavior: "smooth"
    });
  },
  _activateOption(option2) {
    const phxClick = option2.getAttribute("phx-click");
    if (phxClick) {
      executeCommand(this, phxClick);
      return;
    }
    const link = option2.querySelector("a[href], [phx-click]");
    if (link) {
      link.click();
      this._handleDisclosure("hide");
    }
  },
  _getActiveOption() {
    const activeOptionId = this.elements.trigger.getAttribute("aria-activedescendant");
    if (!activeOptionId) {
      return null;
    }
    return this.el.querySelector(`#${activeOptionId}`);
  },
  updated() {
    var _a;
    this.elements.listbox = this.el.querySelector(`[role="listbox"]`);
    this._syncPopover();
    (_a = this.elements).activeOption && (_a.activeOption = document.getElementById(this.elements.activeOption.id));
    this._setOptionAsActive(this.elements.activeOption);
  },
  destroyed() {
    var _a;
    this.el.removeEventListener("keydown", this.handlers.container);
    this.elements.trigger.removeEventListener("keydown", this.handlers.trigger);
    (_a = this._expandedObserver) == null ? void 0 : _a.disconnect();
  }
};

// js/hooks/helpers/error_focus.js
var focusErrorTarget = (targetId) => {
  var _a, _b, _c, _d, _e3;
  const linkTarget = document.getElementById(targetId);
  if (!linkTarget) {
    return;
  }
  const groupInputSelector = 'input[type="radio"], input[type="checkbox"]';
  const focusTarget = (_b = (_a = linkTarget.querySelector(`:is(${groupInputSelector}):checked:not(:disabled)`)) != null ? _a : linkTarget.querySelector(`:is(${groupInputSelector}):not(:disabled)`)) != null ? _b : linkTarget;
  const wrapperSelector = `#${CSS.escape(targetId)}-wrapper`;
  const wrapper = (_c = linkTarget.closest(wrapperSelector)) != null ? _c : document.querySelector(wrapperSelector);
  const scrollTarget = (_e3 = (_d = wrapper == null ? void 0 : wrapper.querySelector("label")) != null ? _d : linkTarget.querySelector("legend")) != null ? _e3 : linkTarget;
  if (focusTarget.tabIndex < 0 && !focusTarget.hasAttribute("tabindex")) {
    focusTarget.setAttribute("tabindex", "-1");
  }
  focusTarget.focus({ preventScroll: true });
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  scrollTarget.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
};

// js/hooks/error_summary.js
var GC_ErrorSummary = {
  mounted() {
    this.wasSubmitted = false;
    this.form = this.findForm();
    this.listEl = this.el.querySelector(".gc-error-summary-list");
    this.refreshFrameId = null;
    this.renderedItemsSignature = null;
    this._abortController = new AbortController();
    this.listEl.addEventListener("click", (event) => this.handleErrorLinkClick(event), {
      signal: this._abortController.signal
    });
    if (this.form) {
      this.form.addEventListener(
        "submit",
        () => {
          this.wasSubmitted = true;
          this.scheduleRefresh();
        },
        { signal: this._abortController.signal }
      );
      this.observer = new MutationObserver((mutations) => this.handleFormMutations(mutations));
      this.observer.observe(this.form, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["aria-invalid", "aria-errormessage", "data-error-summary-prefix", "hidden", "class", "style"]
      });
    }
    this.renderList();
    this.focusErrorSummary();
  },
  destroyed() {
    var _a;
    (_a = this.observer) == null ? void 0 : _a.disconnect();
    if (this.refreshFrameId !== null) {
      cancelAnimationFrame(this.refreshFrameId);
    }
    this._abortController.abort();
  },
  findForm() {
    const formId = this.el.dataset.errorSummaryForm;
    if (!formId) {
      return this.el.closest("form");
    }
    const form = document.getElementById(formId);
    return form instanceof HTMLFormElement ? form : null;
  },
  handleErrorLinkClick(event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link) {
      return;
    }
    event.preventDefault();
    focusErrorTarget(link.getAttribute("href").slice(1));
  },
  handleFormMutations(mutations) {
    if (!this.el.isConnected || mutations.every((mutation) => this.el.contains(mutation.target))) {
      return;
    }
    this.scheduleRefresh();
  },
  scheduleRefresh() {
    if (this.refreshFrameId !== null) {
      return;
    }
    this.refreshFrameId = requestAnimationFrame(() => {
      this.refreshFrameId = null;
      if (!this.el.isConnected) {
        return;
      }
      this.renderList();
      this.focusAfterSubmit();
    });
  },
  focusAfterSubmit() {
    var _a;
    if (!this.wasSubmitted || ((_a = this.form) == null ? void 0 : _a.classList.contains("phx-submit-loading"))) {
      return;
    }
    this.wasSubmitted = false;
    if (!this.isSummaryEmpty()) {
      this.focusErrorSummary();
    } else if (this.form.querySelector('[aria-invalid="true"]')) {
      console.warn(
        "GC_ErrorSummary: the submitted form has invalid controls but none of their errors are rendered, so the summary has nothing to list.",
        this.form
      );
    }
  },
  renderList() {
    const items = this.collectRenderedErrors();
    const itemsSignature = JSON.stringify(items);
    if (itemsSignature === this.renderedItemsSignature) {
      return;
    }
    this.renderedItemsSignature = itemsSignature;
    this.listEl.replaceChildren(
      ...items.map(({ targetId, message }) => {
        const item = document.createElement("li");
        item.className = "gc-error-wrapper";
        const link = document.createElement("a");
        link.className = "gc-a gc-a-sm";
        link.href = `#${targetId}`;
        link.textContent = message;
        item.append(link);
        return item;
      })
    );
  },
  collectRenderedErrors() {
    var _a, _b, _c;
    if (!this.form) {
      return [];
    }
    const seenMessageIds = /* @__PURE__ */ new Set();
    const items = [];
    for (const control of this.form.querySelectorAll('[aria-invalid="true"][aria-errormessage]')) {
      const messageId = control.getAttribute("aria-errormessage");
      if (seenMessageIds.has(messageId)) {
        continue;
      }
      seenMessageIds.add(messageId);
      const messageEl = document.getElementById(messageId);
      if (!messageEl || !this.isVisible(messageEl)) {
        continue;
      }
      const target = this.findFocusableControl(messageId);
      if (!target) {
        continue;
      }
      const prefix = (_b = (_a = target.closest("[data-error-summary-prefix]")) == null ? void 0 : _a.dataset.errorSummaryPrefix) == null ? void 0 : _b.trim();
      for (const error of messageEl.querySelectorAll(".gc-error")) {
        const message = ((_c = error.querySelector("p")) != null ? _c : error).textContent.trim();
        if (message) {
          items.push({ targetId: target.id, message: prefix ? `${prefix}: ${message}` : message });
        }
      }
    }
    return items;
  },
  findFocusableControl(messageId) {
    const carriers = this.form.querySelectorAll(`[aria-invalid="true"][aria-errormessage="${CSS.escape(messageId)}"]`);
    return Array.from(carriers).find((carrier) => carrier.id && !this.isHiddenInput(carrier) && this.isVisible(carrier));
  },
  isHiddenInput(el) {
    return el instanceof HTMLInputElement && el.type === "hidden";
  },
  isVisible(el) {
    return el.checkVisibility ? el.checkVisibility({ checkVisibilityCSS: true }) : !el.hidden;
  },
  isSummaryEmpty() {
    return this.listEl.childElementCount === 0;
  },
  focusErrorSummary() {
    if (this.isSummaryEmpty()) {
      return;
    }
    this.el.focus({ preventScroll: true });
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.el.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
  }
};
var error_summary_default = GC_ErrorSummary;

// js/hooks/combobox.js
var KEYS4 = {
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  HOME: "Home",
  END: "End"
};
var combobox_default = {
  mounted() {
    this.customInputHelpers = createCustomInputHelpers(this);
    this.elements = {
      trigger: this.el.querySelector(`[role="combobox"]`),
      listbox: this.el.querySelector(`[role="listbox"]`),
      clearButton: this.el.querySelector(".gc-input-combobox-search-clear-button-container"),
      hiddenInput: this.el.querySelector("input[type=hidden]")
    };
    this._abortController = new AbortController();
    this.handlers = {
      container: this._handleMainContainerKeydown.bind(this),
      containerFocusOut: this._handleMainContainerFocusOut.bind(this),
      triggerFocus: this._handleTriggerFocus.bind(this),
      triggerKeydown: this._handleTriggerKeydown.bind(this),
      clearButtonClick: this._handleClearButtonClick.bind(this),
      hiddenInput: this.customInputHelpers.bubbleChangeEvent
    };
    this.el.addEventListener("keydown", this.handlers.container, {
      signal: this._abortController.signal
    });
    this.el.addEventListener("focusout", this.handlers.containerFocusOut, {
      signal: this._abortController.signal
    });
    this.elements.trigger.addEventListener("focus", this.handlers.triggerFocus, {
      signal: this._abortController.signal
    });
    this.elements.trigger.addEventListener("keydown", this.handlers.triggerKeydown, {
      signal: this._abortController.signal
    });
    this.elements.clearButton.addEventListener("click", this.handlers.clearButtonClick, {
      signal: this._abortController.signal
    });
    this.handleEvent("combobox:selected", this.handlers.hiddenInput);
    this.handleEvent("combobox:clear", this.handlers.hiddenInput);
    this.el.setAttribute("data-ready", "true");
  },
  _handleMainContainerKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS4.ESCAPE]: () => {
        this.elements.trigger.value = "";
        this._handleDisclosure("clear");
        this._handleDisclosure("hide");
      }
    };
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleMainContainerFocusOut(event) {
    if (!event.relatedTarget || this.el.contains(event.relatedTarget)) {
      return;
    }
    this._handleDisclosure("focusOut");
  },
  _handleTriggerFocus() {
    this._handleDisclosure("show");
  },
  _handleTriggerKeydown(event) {
    if (this._isListExpanded() && this._activeOption()) {
      this._handleTriggerKeydownWithActiveDescendant(event);
    } else {
      this._handleTriggerKeydownWithNoActiveDescendant(event);
    }
  },
  _handleTriggerKeydownWithNoActiveDescendant(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS4.DOWN]: () => this._focusOption(0),
      [KEYS4.UP]: () => this._focusOption(this._isListExpanded() ? -1 : 0)
    };
    this._handleDisclosure("show");
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleTriggerKeydownWithActiveDescendant(event) {
    var _a;
    const { key } = event;
    const options = Array.from(this._fetchOptions());
    const activeOption = this._activeOption();
    const activeOptionIndex = options.indexOf(activeOption);
    const actions = {
      [KEYS4.DOWN]: () => this._focusOption(activeOptionIndex + 1),
      [KEYS4.UP]: () => {
        const pos = activeOptionIndex <= 0 ? 0 : activeOptionIndex - 1;
        this._focusOption(pos);
      },
      [KEYS4.ENTER]: () => {
        document.activeElement.blur();
        executeCommand(this, activeOption.getAttribute("phx-click"));
      },
      [KEYS4.HOME]: () => this._focusOption(0),
      [KEYS4.END]: () => this._focusOption(-1)
    };
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleClearButtonClick() {
    this.elements.trigger.value = "";
    this.elements.trigger.focus();
    this._handleDisclosure("clear");
  },
  _focusOption(position) {
    const options = Array.from(this._fetchOptions());
    const actualPosition = position >= 0 ? position : options.length + position;
    const option2 = options[actualPosition];
    if (!option2) {
      return;
    }
    this._fetchOptions().forEach((el) => el.classList.remove("active"));
    option2.classList.add("active");
    this.elements.trigger.setAttribute("aria-activedescendant", option2.id);
    this.elements.trigger.value = option2.dataset.labelText;
    const optionCoordinates = option2.getBoundingClientRect();
    this.elements.listbox.scrollTo({
      top: optionCoordinates.height * actualPosition,
      left: 0,
      behavior: "smooth"
    });
  },
  _handleDisclosure(action) {
    const commandMap = {
      show: "showDisclosure",
      hide: "hideDisclosure",
      clear: "clearValue",
      focusOut: "focusOut"
    };
    const command = this.el.dataset[commandMap[action]];
    return executeCommand(this, command);
  },
  _fetchOptions() {
    return this.el.querySelectorAll(`[role="option"]`);
  },
  _isListExpanded() {
    return this.elements.trigger.getAttribute("aria-expanded") == "true";
  },
  _getActiveOptionId() {
    return this.elements.trigger.getAttribute("aria-activedescendant");
  },
  _activeOption() {
    return this.el.querySelector(`#${this._getActiveOptionId()}`);
  },
  updated() {
    if (!this._activeOption()) {
      this.elements.trigger.removeAttribute("aria-activedescendant");
    }
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/document_preview.js
var KEYS5 = {
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight",
  ESCAPE: "Escape"
};
var document_preview_default = {
  mounted() {
    this._abortController = new AbortController();
    this.handleEvent("gc:show-document-preview", (data) => {
      (data == null ? void 0 : data.id) === this.el.id && this._show();
    });
    this.handleEvent("gc:hide-document-preview", (data) => {
      (data == null ? void 0 : data.id) === this.el.id && this._hide();
    });
    this.el.addEventListener("keydown", this._handleMainContainerKeydown.bind(this), {
      signal: this._abortController.signal
    });
    this.el.addEventListener("gc:show-document-preview", this._show.bind(this), {
      signal: this._abortController.signal
    });
    this.el.addEventListener("gc:hide-document-preview", this._hide.bind(this), {
      signal: this._abortController.signal
    });
    this.el.setAttribute("data-ready", "true");
  },
  updated() {
    this.el.open && this._setUrlParams();
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
    this._removeUrlParams();
  },
  _show() {
    this._hideOtherDocumentPreviews();
    if (this._isModalOpen()) {
      this._setUrlParams();
      return;
    }
    if (this.el.open) {
      this.el.close();
      this.js().exec(this.el.dataset.hide);
    }
    this.el.showModal();
    this.js().exec(this.el.dataset.show);
    this._setUrlParams();
  },
  _hide() {
    this.el.open && this.el.close();
    this.js().exec(this.el.dataset.hide);
    this._removeUrlParams();
  },
  _hideOtherDocumentPreviews() {
    document.querySelectorAll("dialog[phx-hook='GC_DocumentPreview'][open]").forEach((dialog) => {
      if (dialog.id === this.el.id) return;
      dialog.dispatchEvent(new CustomEvent("gc:hide-document-preview"));
    });
  },
  _isModalOpen() {
    return this.el.matches(":modal");
  },
  _handleMainContainerKeydown(event) {
    var _a;
    if (!this.el.open) return;
    const { key } = event;
    if (key === KEYS5.LEFT && !this._canGoPrevious()) return;
    if (key === KEYS5.RIGHT && !this._canGoNext()) return;
    const actions = {
      [KEYS5.LEFT]: () => {
        this.js().exec(this.el.dataset.goToPrevious);
      },
      [KEYS5.RIGHT]: () => {
        this.js().exec(this.el.dataset.goToNext);
      },
      [KEYS5.ESCAPE]: () => {
        this._hide();
      }
    };
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _canGoPrevious() {
    return this.el.dataset.hasPrevious === "true";
  },
  _canGoNext() {
    return this.el.dataset.hasNext === "true";
  },
  _setUrlParams() {
    const param_name_to_add_in_url = this.el.dataset.paramNameToAddInUrl;
    const id_for_url = this.el.dataset.idForUrl;
    if (!param_name_to_add_in_url || !id_for_url) return;
    const url = new URL(window.location.href);
    url.searchParams.set(param_name_to_add_in_url, id_for_url);
    history.replaceState(history.state, "", url.toString());
  },
  _removeUrlParams() {
    const param_name_to_add_in_url = this.el.dataset.paramNameToAddInUrl;
    if (!param_name_to_add_in_url) return;
    const url = new URL(window.location.href);
    url.searchParams.delete(param_name_to_add_in_url);
    history.replaceState(history.state, "", url.toString());
  }
};

// js/hooks/keyboard_navigation.js
var [DOWN2, UP] = ["ArrowDown", "ArrowUp"];
var keyboard_navigation_default = {
  mounted() {
    this._abortController = new AbortController();
    this.el.addEventListener("keydown", this._handleKeydown.bind(this), {
      signal: this._abortController.signal
    });
  },
  _handleKeydown(event) {
    var _a;
    const items = Array.from(this.el.querySelectorAll("a, button:not([disabled])"));
    if (![DOWN2, UP].includes(event.key)) {
      return;
    }
    event.preventDefault();
    const target = this.el.querySelector("a:focus, button:focus");
    const currentIndex = items.indexOf(target);
    if (currentIndex === -1) {
      (_a = items[0]) == null ? void 0 : _a.focus();
      return;
    }
    const { key } = event;
    if (key === DOWN2) {
      const nextIndex = currentIndex + 1;
      items[nextIndex] ? items[nextIndex].focus() : items[0].focus();
    } else if (key === UP) {
      const prevIndex = currentIndex - 1;
      items[prevIndex] ? items[prevIndex].focus() : items[items.length - 1].focus();
    }
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/live_search.js
var live_search_default = {
  mounted() {
    this.customInputHelpers = createCustomInputHelpers(this);
    this._abortController = new AbortController();
    this._pointerDownInside = false;
    this.elements = {
      input: this.el.querySelector("[role=combobox]"),
      hiddenInput: this.el.querySelector("input[type=hidden]"),
      measureSpan: this.el.querySelector(".gc-live-search-measure-span")
    };
    this.handlers = {
      hiddenInput: this.customInputHelpers.bubbleChangeEvent,
      containerFocusOut: this._handleContainerFocusOut.bind(this),
      containerPointerDown: this._handleContainerPointerDown.bind(this),
      documentPointerUp: this._handleDocumentPointerUp.bind(this)
    };
    this.handleEvent("live_search:selected", this.handlers.hiddenInput);
    this.handleEvent("live_search:clear", this.handlers.hiddenInput);
    this.el.addEventListener("focusout", this.handlers.containerFocusOut, {
      signal: this._abortController.signal
    });
    this.el.addEventListener("pointerdown", this.handlers.containerPointerDown, {
      signal: this._abortController.signal
    });
    document.addEventListener("pointerup", this.handlers.documentPointerUp, {
      signal: this._abortController.signal
    });
    document.addEventListener("pointercancel", this.handlers.documentPointerUp, {
      signal: this._abortController.signal
    });
    this.el.setAttribute("data-ready", "true");
    this.updateInputWidth();
  },
  _handleContainerPointerDown(event) {
    if (event.button === 0) {
      this._pointerDownInside = true;
    }
  },
  _handleDocumentPointerUp() {
    this._pointerDownInside = false;
  },
  _handleContainerFocusOut(event) {
    if (!event.relatedTarget || this.el.contains(event.relatedTarget)) {
      return;
    }
    if (this._pointerDownInside) {
      this._pointerDownInside = false;
      return;
    }
    this.pushEventTo("#" + this.elements.input.id, "reset_text");
  },
  updated() {
    this.updateInputWidth();
  },
  updateInputWidth() {
    if (this.el.querySelector(".gc-live-search-chip-container")) {
      const textWidth = this.elements.measureSpan.offsetWidth;
      const minWidth = 20;
      const padding = 24;
      const extraSpacing = 5;
      const width = Math.max(minWidth, textWidth + padding + extraSpacing);
      this.elements.input.style.width = `${width}px`;
    } else {
      this.elements.input.style.removeProperty("width");
    }
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/modal.js
var modal_default = {
  mounted() {
    this.handleEvent("gc:show-dialog-modal", (data) => {
      (data == null ? void 0 : data.id) === this.el.id && this._show();
    });
    this.handleEvent("gc:hide-dialog-modal", (data) => {
      (data == null ? void 0 : data.id) === this.el.id && this._hide();
    });
  },
  _show() {
    this.el.showModal();
    this.js().exec(this.el.dataset.show);
  },
  _hide() {
    this.el.close();
    this.js().exec(this.el.dataset.hide);
  }
};

// js/hooks/money_formatting.js
var money_formatting_default = {
  mounted() {
    this.handleBlur = (e) => {
      e.preventDefault();
      const input = e.target;
      const value = Number(input.value);
      const fractionalDigits = Number(input.dataset.fractionalDigits);
      if (input.value !== "" && Number.isFinite(value)) {
        input.value = value.toFixed(fractionalDigits);
      }
    };
    this.el.addEventListener("blur", this.handleBlur);
    this.cleanup = () => {
      this.el.removeEventListener("blur", this.handleBlur);
    };
  },
  destroyed() {
    var _a;
    (_a = this.cleanup) == null ? void 0 : _a.call(this);
  }
};

// js/hooks/password_visibility.js
var LABELS = {
  show: "Show password",
  hide: "Hide password"
};
var VISIBILITY_TIMEOUT = 5e3;
var getIconState = (isVisible) => ({
  isEyeSlash: isVisible,
  ariaPressed: !isVisible,
  ariaLabel: isVisible ? LABELS.show : LABELS.hide,
  inputType: isVisible ? "password" : "text"
});
var updateIcon = (button, iconSpanElements, isEyeSlash) => {
  if (!iconSpanElements || !button) return;
  iconSpanElements.forEach((iconSpan) => {
    const iconId = iconSpan.dataset.iconId;
    iconSpan.toggleAttribute("hidden");
  });
};
var updateDOM = (button, icon, input) => (state) => {
  updateIcon(button, icon, state.isEyeSlash);
  button.setAttribute("aria-pressed", state.ariaPressed);
  button.setAttribute("aria-label", state.ariaLabel);
  button.setAttribute("title", state.ariaLabel);
  input.type = state.inputType;
};
var password_visibility_default = {
  mounted() {
    const input = this.el.querySelector("input");
    const button = this.el.querySelector("button");
    const icons = button == null ? void 0 : button.querySelectorAll(".gc-icon");
    this.toggle = this.el.querySelector(".input-icon-toggle-button");
    let visibilityTimeout = null;
    const update = updateDOM(button, icons, input);
    const toggleVisibility = () => {
      if (visibilityTimeout) {
        window.clearTimeout(visibilityTimeout);
        visibilityTimeout = null;
      }
      const isVisible = input.type === "text";
      const state = getIconState(isVisible);
      update(state);
      if (state.inputType === "text") {
        visibilityTimeout = window.setTimeout(() => {
          update(getIconState(true));
          visibilityTimeout = null;
        }, VISIBILITY_TIMEOUT);
      }
    };
    this.handleMouseDown = (e) => {
      e.preventDefault();
      if (e.target === input) {
        if (document.activeElement === input) {
          toggleVisibility();
        }
        input.focus();
      } else {
        toggleVisibility();
      }
    };
    this.handleKeydown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleVisibility();
      }
    };
    this.toggle.addEventListener("mousedown", this.handleMouseDown);
    this.toggle.addEventListener("keydown", this.handleKeydown);
    this.cleanup = () => {
      this.toggle.removeEventListener("mousedown", this.handleMouseDown);
      this.toggle.removeEventListener("keydown", this.handleKeydown);
    };
  },
  destroyed() {
    var _a;
    (_a = this.cleanup) == null ? void 0 : _a.call(this);
  }
};

// js/hooks/picker_card.js
var KEYS6 = {
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " "
};
var picker_card_default = {
  mounted() {
    var _a, _b;
    this._abortController = new AbortController();
    this.elements = {
      picker: this.el.querySelector(`.gc-picker-card-picker input`),
      footer: this.el.querySelector(`.gc-picker-card-footer`),
      firstFooterInput: this.el.querySelector(`.gc-picker-card-footer input`)
    };
    this.handlers = {
      containerClick: this._handleMainContainerClick.bind(this),
      containerMousedown: this._handleMainContainerMousedown.bind(this),
      containerKeydown: this._handleMainContainerKeydown.bind(this),
      pickerChange: this._handlePickerChange.bind(this),
      pickerKeydown: this._handlePickerKeydown.bind(this)
    };
    this.el.addEventListener("click", this.handlers.containerClick, {
      signal: this._abortController.signal
    });
    this.el.addEventListener("mousedown", this.handlers.containerMousedown, {
      signal: this._abortController.signal
    });
    this.el.addEventListener("keydown", this.handlers.containerKeydown, {
      signal: this._abortController.signal
    });
    (_a = this.elements.picker) == null ? void 0 : _a.addEventListener("change", this.handlers.pickerChange, {
      signal: this._abortController.signal
    });
    (_b = this.elements.picker) == null ? void 0 : _b.addEventListener("keydown", this.handlers.pickerKeydown, {
      signal: this._abortController.signal
    });
  },
  _handleMainContainerClick(event) {
    const { target } = event;
    const pickerInput = this.elements.picker;
    const footer = this.elements.footer;
    const isPickerInput = pickerInput && target === pickerInput;
    const isFooter = footer && footer.contains(target);
    if (isPickerInput || isFooter) return;
    this._togglePicker();
  },
  _handleMainContainerMousedown(event) {
    const { target } = event;
    const footer = this.elements.footer;
    if (footer && footer.contains(target)) {
      event.stopPropagation();
    }
  },
  _handleMainContainerKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS6.ESCAPE]: () => {
        var _a2;
        event.preventDefault();
        (_a2 = this.elements.picker) == null ? void 0 : _a2.focus();
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handlePickerChange() {
    const pickerInput = this.elements.picker;
    if (!pickerInput) return;
    if (pickerInput.checked) {
      setTimeout(() => {
        var _a;
        (_a = this.elements.firstFooterInput) == null ? void 0 : _a.focus();
      }, 400);
    }
  },
  _handlePickerKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS6.ENTER]: () => {
        event.preventDefault();
        this._togglePicker();
      },
      [KEYS6.SPACE]: () => {
        event.preventDefault();
        this._togglePicker();
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _togglePicker() {
    const pickerInput = this.elements.picker;
    if (!pickerInput) return;
    pickerInput.click();
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/picker_card_group.js
var KEYS7 = {
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  HOME: "Home",
  END: "End"
};
var picker_card_group_default = {
  mounted() {
    this._abortController = new AbortController();
    this.elements = {
      pickerCards: this.el.querySelectorAll(`.gc-picker-card`)
    };
    this.handlers = {
      containerKeydown: this._handleMainContainerKeydown.bind(this)
    };
    this.el.addEventListener("keydown", this.handlers.containerKeydown, {
      signal: this._abortController.signal
    });
  },
  _handleMainContainerKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS7.DOWN]: () => {
        event.preventDefault();
        this._focusNextCard();
      },
      [KEYS7.UP]: () => {
        event.preventDefault();
        this._focusPreviousCard();
      },
      [KEYS7.HOME]: () => {
        event.preventDefault();
        this._focusFirstCard();
      },
      [KEYS7.END]: () => {
        event.preventDefault();
        this._focusLastCard();
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _focussedCard() {
    return Array.from(this.elements.pickerCards).find((card) => card.contains(document.activeElement));
  },
  _focusNextCard() {
    const currentFocussedCard = this._focussedCard();
    currentFocussedCard ? this._focusCard(currentFocussedCard.nextElementSibling) : this._focusFirstCard();
  },
  _focusPreviousCard() {
    const currentFocussedCard = this._focussedCard();
    currentFocussedCard ? this._focusCard(currentFocussedCard.previousElementSibling) : this._focusLastCard();
  },
  _focusFirstCard() {
    const firstCard = this.elements.pickerCards[0];
    this._focusCard(firstCard);
  },
  _focusLastCard() {
    const lastCard = this.elements.pickerCards[this.elements.pickerCards.length - 1];
    this._focusCard(lastCard);
  },
  _focusCard(card) {
    if (!card) return;
    card.querySelector(`.gc-picker-card-picker input`).focus();
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/select.js
var KEYS8 = {
  DOWN: "ArrowDown",
  UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  HOME: "Home",
  END: "End"
};
var select_default = {
  mounted() {
    this._abortController = new AbortController();
    this.elements = {
      trigger: document.getElementById(this.el.getAttribute("aria-labelledby")),
      listbox: this.el
    };
    this.handlers = {
      triggerKeydown: this._handleTriggerKeydown.bind(this),
      triggerFocus: this._handleTriggerFocus.bind(this)
    };
    this.elements.trigger.addEventListener("keydown", this.handlers.triggerKeydown, {
      signal: this._abortController.signal
    });
    this.elements.trigger.addEventListener("focus", this.handlers.triggerFocus, {
      signal: this._abortController.signal
    });
    this.el.setAttribute("data-ready", "true");
  },
  _handleTriggerKeydown(event) {
    if (this._isListExpanded() && this._getActiveOption()) {
      this._handleTriggerKeydownWithActiveDescendant(event);
    } else {
      this._handleTriggerKeydownWithNoActiveDescendant(event);
    }
  },
  _handleTriggerKeydownWithNoActiveDescendant(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS8.DOWN]: () => this._focusOption("first"),
      [KEYS8.UP]: () => this._focusOption(this._isListExpanded() ? "last" : "first"),
      [KEYS8.ESCAPE]: () => {
        this.elements.trigger.value = "";
        this.pushEventTo("#" + this.elements.trigger.id, "clear");
      }
    };
    if (!actions[key]) return;
    event.preventDefault();
    if (key === KEYS8.ESCAPE || this._isListExpanded()) {
      (_a = actions[key]) == null ? void 0 : _a.call(actions);
    }
  },
  _handleTriggerKeydownWithActiveDescendant(event) {
    var _a;
    const { key } = event;
    const activeOption = this._getActiveOption();
    const options = Array.from(this._fetchOptions());
    const activeOptionIndex = options.indexOf(activeOption);
    const actions = {
      [KEYS8.DOWN]: () => this._focusOption(activeOptionIndex + 1),
      [KEYS8.UP]: () => {
        const pos = activeOptionIndex <= 0 ? 0 : activeOptionIndex - 1;
        this._focusOption(pos);
      },
      [KEYS8.ENTER]: () => {
        this._activateOption(activeOption);
      },
      [KEYS8.ESCAPE]: () => {
        this._clearActiveDescendant();
        this.elements.trigger.value = "";
        this.pushEventTo("#" + this.elements.trigger.id, "clear");
      },
      [KEYS8.HOME]: () => this._focusOption("first"),
      [KEYS8.END]: () => this._focusOption("last")
    };
    if (!actions[key]) return;
    event.preventDefault();
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  _handleTriggerFocus() {
    this.pushEventTo("#" + this.elements.trigger.id, "focus");
  },
  _fetchOptions() {
    return this.el.querySelectorAll(`[role="option"]`);
  },
  _isListExpanded() {
    return this.elements.trigger.getAttribute("aria-expanded") == "true";
  },
  _focusOption(position) {
    const options = Array.from(this._fetchOptions());
    let option2;
    if (position === "first") {
      option2 = options[0];
    } else if (position === "last") {
      option2 = options[options.length - 1];
    } else {
      option2 = options[position];
    }
    if (!option2) return;
    this._setOptionAsActive(option2);
  },
  _setOptionAsActive(option2) {
    this._fetchOptions().forEach((el) => {
      el.classList.remove("active");
      el.setAttribute("aria-selected", "false");
    });
    option2.classList.add("active");
    option2.setAttribute("aria-selected", "true");
    this.elements.trigger.setAttribute("aria-activedescendant", option2.id);
    const optionCoordinates = option2.getBoundingClientRect();
    const options = Array.from(this._fetchOptions());
    const optionIndex = options.indexOf(option2);
    this.elements.listbox.scrollTo({
      top: optionCoordinates.height * optionIndex,
      left: 0,
      behavior: "smooth"
    });
  },
  _clearActiveDescendant() {
    this._fetchOptions().forEach((el) => {
      el.classList.remove("active");
      el.setAttribute("aria-selected", "false");
    });
    this.elements.trigger.removeAttribute("aria-activedescendant");
  },
  _activateOption(option2) {
    const phxClick = option2.getAttribute("phx-click");
    if (phxClick) {
      executeCommand(this, phxClick);
      return;
    }
    const link = option2.querySelector("a[href], [phx-click]");
    if (link) {
      link.click();
    }
  },
  _getActiveOption() {
    const activeOptionId = this.elements.trigger.getAttribute("aria-activedescendant");
    if (!activeOptionId) return null;
    return this.el.querySelector(`#${activeOptionId}`);
  },
  updated() {
    const activeOption = this._getActiveOption();
    if (!activeOption || activeOption.getAttribute("aria-selected") !== "true") {
      this.elements.trigger.removeAttribute("aria-activedescendant");
    }
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/table.js
var SCROLLABLE_OVERFLOW = ["auto", "scroll", "hidden"];
var PRIMARY_LINK = ".gc-table-primary-column a";
var INTERACTIVE = "a, button, input, select, textarea, label, [role='button']";
var table_default = {
  mounted() {
    this._controller = new AbortController();
    this.setupRowClick();
    this.setupStickyHeader();
  },
  destroyed() {
    var _a;
    this._controller.abort();
    (_a = this._stickyObserver) == null ? void 0 : _a.disconnect();
  },
  setupRowClick() {
    this.el.addEventListener("click", (event) => this.navigateRow(event), {
      signal: this._controller.signal
    });
  },
  navigateRow(event) {
    var _a;
    const cell = event.target.closest("td");
    if (!cell) return;
    if (cell.classList.contains("gc-table-action")) return;
    if (event.target.closest(INTERACTIVE)) return;
    const link = (_a = cell.closest("tr")) == null ? void 0 : _a.querySelector(PRIMARY_LINK);
    link == null ? void 0 : link.click();
  },
  setupStickyHeader() {
    const thead = this.el.querySelector("thead");
    const wrapper = this.el.closest(".gc-table-sticky");
    const sentinel = wrapper == null ? void 0 : wrapper.querySelector(".gc-table-sticky-sentinel");
    if (!thead || !sentinel) return;
    const toggleShadow = ([entry]) => {
      thead.classList.toggle("gc-stuck", !entry.isIntersecting);
    };
    this._stickyObserver = new IntersectionObserver(toggleShadow, {
      root: this.getScrollParent(wrapper),
      threshold: 0
    });
    this._stickyObserver.observe(sentinel);
  },
  getScrollParent(element) {
    for (let el = element.parentElement; el; el = el.parentElement) {
      if (!this.isScrollable(el)) continue;
      if (el === document.documentElement || el === document.body) return null;
      return el;
    }
    return null;
  },
  isScrollable(element) {
    return SCROLLABLE_OVERFLOW.includes(getComputedStyle(element).overflowY);
  }
};

// js/hooks/tabs.js
var KEYS9 = {
  RIGHT: "ArrowRight",
  LEFT: "ArrowLeft",
  SPACE: " ",
  HOME: "Home",
  END: "End"
};
var tabs_default = {
  mounted() {
    this.elements = {
      tablist: this.el.querySelector(`[role="tablist"]`),
      tabs: this.el.querySelectorAll(`[role="tab"]`)
    };
    this.handlers = {
      trigger: this._handleTriggerKeydown.bind(this)
    };
    this._scrollToActiveTabInsideTablist();
    this.el.addEventListener("keydown", this.handlers.trigger);
  },
  destroyed() {
    this.el.removeEventListener("keydown", this.handlers.trigger);
  },
  _scrollToActiveTabInsideTablist() {
    const activeTab = this._getActiveTab();
    if (!activeTab) return;
    const tablistRect = this.elements.tablist.getBoundingClientRect();
    const activeTabRect = activeTab.getBoundingClientRect();
    const isFullyVisible = activeTabRect.left >= tablistRect.left && activeTabRect.right <= tablistRect.right;
    if (isFullyVisible) return;
    this.elements.tablist.scrollTo({
      left: activeTabRect.left - tablistRect.left,
      behavior: "smooth"
    });
  },
  _getActiveTab() {
    const tabs = Array.from(this.elements.tabs);
    return tabs.find((el) => el.classList.contains("gc-active"));
  },
  _setTabAsFocused(target) {
    if (!target) return;
    this.elements.tabs.forEach((el) => el.setAttribute("tabindex", "-1"));
    target.setAttribute("tabindex", "0");
    target.focus();
  },
  _handleTriggerKeydown(event) {
    const { key } = event;
    const tabs = Array.from(this.elements.tabs);
    const currentIndex = tabs.indexOf(event.target);
    const actions = {
      [KEYS9.RIGHT]: () => {
        const nextIndex = (currentIndex + 1) % tabs.length;
        this._setTabAsFocused(tabs[nextIndex]);
      },
      [KEYS9.LEFT]: () => {
        const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        this._setTabAsFocused(tabs[prevIndex]);
      },
      [KEYS9.HOME]: () => this._setTabAsFocused(tabs[0]),
      [KEYS9.END]: () => this._setTabAsFocused(tabs.at(-1)),
      [KEYS9.SPACE]: () => event.target.click()
    };
    if (!actions[key]) return;
    event.preventDefault();
    actions[key]();
  }
};

// js/hooks/custom_time_input.js
var custom_time_input_default = {
  mounted() {
    this.elements = {
      textInput: this.el.querySelector('input[type="text"]'),
      hiddenInput: this.el.querySelector('input[type="hidden"]')
    };
    this.currentTextValue = this.elements.hiddenInput.value;
    this._abortController = new AbortController();
    this._initializeValue();
    this.elements.textInput.addEventListener("input", this._handleChange.bind(this), {
      signal: this._abortController.signal
    });
    this.el.setAttribute("data-ready", "true");
  },
  updated() {
    const parsed = this._parseTimeInput(this.currentTextValue);
    const iso8601Time = (parsed == null ? void 0 : parsed.isValid) ? this._convertToISO8601(parsed.hours, parsed.minutes, parsed.period) : null;
    this.elements.textInput.setAttribute("value", this.currentTextValue);
    this.elements.textInput.value = this.currentTextValue;
    if (this.elements.hiddenInput.value !== iso8601Time) {
      this._initializeValue();
    }
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  },
  _initializeValue() {
    const displayValue = this._parseISO8601ToDisplay(this.elements.hiddenInput.value) || this.elements.hiddenInput.value.replace(/^invalid:/, "");
    this.elements.textInput.setAttribute("value", displayValue);
    this.elements.textInput.value = displayValue;
    this.currentTextValue = displayValue;
  },
  _handleChange(event) {
    const value = event.target.value;
    const parsed = this._parseTimeInput(value);
    this.currentTextValue = value;
    if (parsed == null ? void 0 : parsed.isValid) {
      this.elements.hiddenInput.value = this._convertToISO8601(parsed.hours, parsed.minutes, parsed.period);
    } else if (!value.trim()) {
      this.elements.hiddenInput.value = "";
    } else {
      this.elements.hiddenInput.value = `invalid:${value}`;
    }
    this.elements.hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
  },
  _parseTimeInput(input) {
    var _a;
    if (!input || typeof input !== "string") {
      return null;
    }
    const trimmed = input.trim().toLowerCase();
    if (trimmed === "noon") {
      return { hours: 12, minutes: 0, period: "pm", isValid: true };
    }
    if (trimmed === "midnight") {
      return { hours: 12, minutes: 0, period: "am", isValid: true };
    }
    const normalized = trimmed.replace(/\s+/g, " ");
    const timePattern = /^(\d{1,2})(?:[:.]\s*(\d{2}))?\s*(am?|pm?|a\.m\.|p\.m\.)?$/i;
    const match = normalized.match(timePattern);
    if (!match) {
      return { isValid: false };
    }
    const hours = parseInt(match[1], 10);
    const minutes = match[2] ? parseInt(match[2], 10) : 0;
    let period = (_a = match[3]) == null ? void 0 : _a.replace(/\./g, "").toLowerCase();
    if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59 || !["am", "pm"].includes(period)) {
      return { isValid: false };
    }
    return { hours, minutes, period, isValid: true };
  },
  _convertToISO8601(hours, minutes, period) {
    let hour24 = hours;
    if (period === "am") {
      if (hours === 12) {
        hour24 = 0;
      }
    } else if (period === "pm") {
      if (hours !== 12) {
        hour24 = hours + 12;
      }
    }
    const h2 = hour24.toString().padStart(2, "0");
    const m = minutes.toString().padStart(2, "0");
    return `${h2}:${m}:00`;
  },
  _parseISO8601ToDisplay(iso8601Time) {
    if (!iso8601Time) return null;
    const match = iso8601Time.match(/^(\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return null;
    const date = /* @__PURE__ */ new Date(`1970-01-01T${iso8601Time}`);
    const formatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
    return formatter.format(date).toLowerCase();
  }
};

// js/hooks/toggle.js
var GC_Toggle = {
  mounted() {
    this._abortController = new AbortController();
    this.elements = {
      toggle: this.el.querySelector(".gc-toggle-switch"),
      input: this.el.querySelector("input[data-toggle]")
    };
    if (!this.elements.toggle || !this.elements.input) return;
    this.elements.toggle.addEventListener(
      "click",
      () => {
        if (this.elements.input.disabled) return;
        this.elements.input.click();
      },
      { signal: this._abortController.signal }
    );
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};
var toggle_default = GC_Toggle;

// node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  var _padding$top, _padding$right, _padding$bottom, _padding$left;
  return {
    top: (_padding$top = padding.top) != null ? _padding$top : 0,
    right: (_padding$right = padding.right) != null ? _padding$right : 0,
    bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
    left: (_padding$left = padding.left) != null ? _padding$left : 0
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x2,
    right: x2 + width,
    bottom: y + height,
    x: x2,
    y
  };
}

// node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  const alignment = getAlignment(placement);
  if (alignment) {
    coords[alignmentAxis] += commonAlign * (alignment === "end" ? 1 : -1) * (rtl && isVertical ? -1 : 1);
  }
  return coords;
}
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) && await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var MAX_RESET_COUNT = 50;
var computePosition = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const platformWithDetectOverflow = platform2.detectOverflow ? platform2 : __spreadProps(__spreadValues({}, platform2), {
    detectOverflow
  });
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y = nextY != null ? nextY : y;
    middlewareData[name] = __spreadValues(__spreadValues({}, middlewareData[name]), data);
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
var arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x: x2,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(minPadding, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: __spreadValues({
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset
      }, shouldAddOffset && {
        alignmentOffset
      }),
      reset: shouldAddOffset
    };
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const _a = evaluate(options, state), {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true
      } = _a, detectOverflowOptions = __objRest(_a, [
        "mainAxis",
        "crossAxis",
        "fallbackPlacements",
        "fallbackStrategy",
        "fallbackAxisSideDirection",
        "flipAlignment"
      ]);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x2,
        y,
        placement,
        platform: platform2
      } = state;
      const _a = evaluate(options, state), {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y2
            } = _ref;
            return {
              x: x3,
              y: y2
            };
          }
        }
      } = _a, detectOverflowOptions = __objRest(_a, [
        "mainAxis",
        "crossAxis",
        "limiter"
      ]);
      const coords = {
        x: x2,
        y
      };
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const clampCoord = (axis, coord) => clamp(coord + overflow[axis === "y" ? "top" : "left"], coord, coord - overflow[axis === "y" ? "bottom" : "right"]);
      if (checkMainAxis) {
        mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
      }
      if (checkCrossAxis) {
        crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
      }
      const limitedCoords = limiter.fn(__spreadProps(__spreadValues({}, state), {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      }));
      return __spreadProps(__spreadValues({}, limitedCoords), {
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      });
    }
  };
};

// node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(":popover-open")) {
      return true;
    }
  } catch (_e3) {
  }
  try {
    return element.matches(":modal");
  } catch (_e3) {
    return false;
  }
}
var willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var containRe = /paint|layout|strict|content/;
var isNotNone = (value) => !!value && value !== "none";
var isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css2 = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return isNotNone(css2.transform) || isNotNone(css2.translate) || isNotNone(css2.scale) || isNotNone(css2.rotate) || isNotNone(css2.perspective) || !isWebKit() && (isNotNone(css2.backdropFilter) || isNotNone(css2.filter)) || willChangeRe.test(css2.willChange || "") || containRe.test(css2.contain || "");
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return (node.ownerDocument || node).body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css2 = getComputedStyle2(element);
  let width = parseFloat(css2.width) || 0;
  let height = parseFloat(css2.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x: x2,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  return !!floatingOffsetParent && isFixed && floatingOffsetParent === getWindow(element);
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement && offsetParent) {
    const win = getWindow(domElement);
    const offsetWin = isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css2 = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css2.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css2.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
function getDocumentRect(html) {
  const scroll = getNodeScroll(html);
  const body = html.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(html);
  const y = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy, rootBoundary) {
  if (rootBoundary === void 0) {
    rootBoundary = "viewport";
  }
  const isLayoutViewport = rootBoundary === "layoutViewport";
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y = 0;
  if (visualViewport) {
    const layoutRelativeClientCoords = !isWebKit() || strategy === "fixed";
    if (isLayoutViewport) {
      if (!layoutRelativeClientCoords) {
        x2 = -visualViewport.offsetLeft;
        y = -visualViewport.offsetTop;
      }
    } else {
      width = visualViewport.width;
      height = visualViewport.height;
      if (layoutRelativeClientCoords) {
        x2 = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    const gutter = getComputedStyle(html).scrollbarGutter === "stable both-edges" ? reservedWidth / 2 : reservedWidth;
    if (gutter <= SCROLLBAR_MAX) {
      width -= gutter;
    }
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = getScale(element);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport" || clippingAncestor === "layoutViewport") {
    rect = getViewportRect(element, strategy, clippingAncestor);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let lastKeptComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? "fixed" : "";
    const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === "fixed" || lastPosition === "absolute" && computedStyle.position === "static");
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      lastKeptComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top = max(rect.top, top);
    right = min(rect.right, right);
    bottom = min(rect.bottom, bottom);
    left = max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  if (!isOffsetParentAnElement && documentElement) {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove, ancestorResize) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (!rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        return refresh();
      }
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, __spreadProps(__spreadValues({}, options), {
        // Handle <iframe>s
        root: root.ownerDocument
      }));
    } catch (_e3) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  const win = getWindow(element);
  const handleResize = () => refresh(ancestorResize);
  win.addEventListener("resize", handleResize);
  refresh(true);
  return () => {
    win.removeEventListener("resize", handleResize);
    cleanup();
  };
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating ? getOverflowAncestors(floating) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update);
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update, ancestorResize) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var shift2 = shift;
var flip2 = flip;
var arrow2 = arrow;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = options != null ? options : {};
  const platformWithCache = __spreadProps(__spreadValues(__spreadValues({}, platform), mergedOptions.platform), {
    _c: cache
  });
  return computePosition(reference, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};

// js/hooks/tooltip.js
var OFFSET = 2;
var HIDE_DELAY_MS = 300;
var PLACEMENTS = {
  top: "top-start",
  bottom: "bottom-start"
};
var FALLBACK_PLACEMENTS = {
  top: ["bottom-start"],
  bottom: ["top-start"]
};
var visibleTooltips = /* @__PURE__ */ new Set();
var tooltip_default = {
  mounted() {
    this._abortController = new AbortController();
    const { signal } = this._abortController;
    const target = document.getElementById(this.el.dataset.for);
    const container = this.el.parentElement;
    const placement = this.el.dataset.placement;
    const arrowElement = this.el.querySelector(".gc-tooltip-arrow");
    this.el.dataset.side = placement;
    this._hideTimeout = null;
    const show = () => {
      for (const other of [...visibleTooltips]) {
        if (other !== this) other._forceHide();
      }
      visibleTooltips.add(this);
      clearTimeout(this._hideTimeout);
      this.el.parentElement.style.display = "flex";
      computePosition2(target, container, {
        placement: PLACEMENTS[placement],
        middleware: [
          flip2({ fallbackPlacements: FALLBACK_PLACEMENTS[placement] }),
          shift2(),
          arrow2({ element: arrowElement, padding: 12 })
        ]
      }).then(({ x: x2, y, placement: resolvedPlacement, middlewareData }) => {
        var _a;
        const side = resolvedPlacement.split("-")[0];
        const arrowX = (_a = middlewareData.arrow) == null ? void 0 : _a.x;
        this.el.dataset.side = side;
        Object.assign(arrowElement.style, {
          left: arrowX != null ? `${arrowX}px` : ""
        });
        Object.assign(container.style, {
          left: `${x2}px`,
          top: `${y + (side === "top" ? -OFFSET : OFFSET)}px`
        });
      });
    };
    const hide2 = () => {
      visibleTooltips.delete(this);
      container.style.display = "none";
    };
    const hideWithDelay = () => {
      this._hideTimeout = setTimeout(hide2, HIDE_DELAY_MS);
    };
    this._forceHide = () => {
      clearTimeout(this._hideTimeout);
      hide2();
    };
    const onKeydown = (e) => {
      if (e.key === "Escape") {
        hide2();
      }
    };
    target.addEventListener("mouseenter", show, { signal });
    target.addEventListener(
      "mouseleave",
      () => {
        if (document.activeElement !== target) {
          hideWithDelay();
        }
      },
      { signal }
    );
    target.addEventListener("focus", show, { signal });
    target.addEventListener("blur", hide2, { signal });
    target.addEventListener("click", hide2, { signal });
    target.addEventListener("keydown", onKeydown, { signal });
    container.addEventListener("mouseenter", show, { signal });
    container.addEventListener(
      "mouseleave",
      () => {
        if (document.activeElement !== target) {
          hideWithDelay();
        }
      },
      { signal }
    );
  },
  destroyed() {
    var _a;
    visibleTooltips.delete(this);
    clearTimeout(this._hideTimeout);
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/chip.js
var KEYS10 = {
  ENTER: "Enter",
  SPACE: " "
};
var chip_default = {
  mounted() {
    this._abortController = new AbortController();
    this.elements = {
      close: this.el.querySelector(".gc-chip-close")
    };
    if (!this.elements.close) return;
    this.handlers = {
      closeKeydown: this._handleCloseKeydown.bind(this)
    };
    this.elements.close.addEventListener("keydown", this.handlers.closeKeydown, {
      signal: this._abortController.signal
    });
  },
  _handleCloseKeydown(event) {
    var _a;
    const { key } = event;
    const actions = {
      [KEYS10.ENTER]: () => {
        event.preventDefault();
        event.stopPropagation();
        executeCommand(this, this.elements.close.getAttribute("phx-click"));
      },
      [KEYS10.SPACE]: () => {
        event.preventDefault();
        event.stopPropagation();
        executeCommand(this, this.elements.close.getAttribute("phx-click"));
      }
    };
    (_a = actions[key]) == null ? void 0 : _a.call(actions);
  },
  destroyed() {
    var _a;
    (_a = this._abortController) == null ? void 0 : _a.abort();
  }
};

// js/hooks/flash.js
var flash_default = {
  mounted() {
    const timeout = this.el.dataset.timeout || 5e3;
    const command = this.el.querySelector("button").getAttribute("phx-click");
    const hide2 = () => this.js().exec(command);
    this.timer = setTimeout(() => hide2(), timeout);
    this.el.addEventListener("phx:hide-start", () => clearTimeout(this.timer));
    this.el.addEventListener("mouseover", () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => hide2(), timeout);
    });
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};

// js/hooks/disable_autofill.js
var disable_autofill_default = {
  mounted() {
    this._input = this.el;
    this._abortController = new AbortController();
    this.handlers = {
      enable: this._enable.bind(this)
    };
    this._input.addEventListener("mousedown", this.handlers.enable, { once: true, signal: this._abortController.signal });
    this._input.addEventListener("touchstart", this.handlers.enable, { once: true, signal: this._abortController.signal });
    this._input.addEventListener("focusin", this.handlers.enable, { once: true, signal: this._abortController.signal });
    this._timeout = setTimeout(() => this._enable(), 3e3);
  },
  updated() {
    this._enable();
  },
  destroyed() {
    var _a;
    clearTimeout(this._timeout);
    (_a = this._abortController) == null ? void 0 : _a.abort();
  },
  _enable() {
    this._input.removeAttribute("readonly");
    this._input.removeAttribute("data-autofill-guard");
    clearTimeout(this._timeout);
    this._abortController.abort();
  }
};

// node_modules/sortablejs/modular/sortable.esm.js
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var version = "1.15.7";
function userAgent(pattern) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on2(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector) return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType && el.host !== el ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx) break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container, "border-top-width"));
          left -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i = 0, children = el.children;
  while (i < children.length) {
    if (children[i].style.display !== "none" && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x2, y) {
  el.scrollLeft += x2;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $2 = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($2) {
    return $2(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
function getChildContainingRectFromElement(container, options, ghostEl2) {
  var rect = {};
  Array.from(container.children).forEach(function(child) {
    var _rect$left, _rect$top, _rect$right, _rect$bottom;
    if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl2) return;
    var childRect = getRect(child);
    rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
    rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
    rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
    rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
  });
  rect.width = rect.right - rect.left;
  rect.height = rect.bottom - rect.top;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
var expando = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function") callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function") callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function") callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults[option2];
      }
    }
    plugins.forEach(function(p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2)) continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function") return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable) return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl;
var parentEl;
var ghostEl;
var rootEl;
var nextEl;
var lastDownEl;
var cloneEl;
var cloneHidden;
var oldIndex;
var newIndex;
var oldDraggableIndex;
var newDraggableIndex;
var activeGroup;
var putSortable;
var awaitingDragStarted = false;
var ignoreNextClick = false;
var sortables = [];
var tapEvt;
var touchEvt;
var lastDx;
var lastDy;
var tapDistanceLeft;
var tapDistanceTop;
var moved;
var lastTarget;
var lastDirection;
var pastFirstInvertThresh = false;
var isCircumstantialInvert = false;
var targetMoveDistance;
var ghostRelativeParent;
var ghostRelativeParentInitialScroll = [];
var _silent = false;
var savedInputChecked = [];
var documentExists = typeof document !== "undefined";
var PositionGhostAbsolutely = IOS;
var CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float";
var supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div");
var supportCssPointerEvents = function() {
  if (!documentExists) return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}();
var _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
};
var _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
};
var _detectNearestEmptySortable = function _detectNearestEmptySortable2(x2, y) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable), insideHorizontally = x2 >= rect.left - threshold && x2 <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
};
var _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
};
var _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
};
var _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists && !ChromeForAndroid) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && (!Safari || IOS),
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on2(el, "pointerdown", this._onTapStart);
  } else {
    on2(el, "mousedown", this._onTapStart);
    on2(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on2(el, "dragover", this);
    on2(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable) return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable);
    if (typeof filter === "function") {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent2("filter", _this, {
          evt
        });
        preventOnFilter && evt.preventDefault();
        return;
      }
    } else if (filter) {
      filter = filter.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent2("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent2("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on2(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on2(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on2(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      if (options.supportPointer) {
        on2(ownerDocument, "pointerup", _this._onDrop);
        !this.nativeDraggable && on2(ownerDocument, "pointercancel", _this._onDrop);
      } else {
        on2(ownerDocument, "mouseup", _this._onDrop);
        on2(ownerDocument, "touchend", _this._onDrop);
        on2(ownerDocument, "touchcancel", _this._onDrop);
      }
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent2("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        if (options.supportPointer) {
          on2(ownerDocument, "pointerup", _this._disableDelayedDrag);
          on2(ownerDocument, "pointercancel", _this._disableDelayedDrag);
        } else {
          on2(ownerDocument, "mouseup", _this._disableDelayedDrag);
          on2(ownerDocument, "touchend", _this._disableDelayedDrag);
          on2(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        }
        on2(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on2(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on2(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "pointerup", this._disableDelayedDrag);
    off(ownerDocument, "pointercancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on2(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on2(document, "touchmove", this._onTouchMove);
      } else {
        on2(document, "mousemove", this._onTouchMove);
      }
    } else {
      on2(dragEl, "dragend", this);
      on2(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent2("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on2(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = getParentOrHost(parent));
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent2("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent2("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.removeAttribute("id");
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent2("clone", _this);
      if (Sortable.eventCanceled) return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on2(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on2(document, "selectstart", _this);
    moved = true;
    window.getSelection().removeAllRanges();
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent) return;
    function dragOverEvent(name, extra) {
      pluginEvent2(name, _this, _objectSpread2({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled) return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled) return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          if (elLastChild && elLastChild.nextSibling) {
            el.insertBefore(dragEl, elLastChild.nextSibling);
          } else {
            el.appendChild(dragEl);
          }
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "pointercancel", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent2("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent2("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    var el = this.el;
    savedInputChecked.forEach(function(checkEl) {
      if (el.contains(checkEl)) {
        checkEl.checked = true;
      }
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
    for (; i < n; i++) {
      el = children[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i) {
      var el = rootEl2.children[i];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent2("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent2("hideClone", this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent2("showClone", this);
      if (Sortable.eventCanceled) return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on2(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on: on2,
  off,
  css,
  find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend,
  throttle,
  closest,
  toggleClass,
  clone,
  index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild,
  expando
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array) plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [];
var scrollEl;
var scrollRootEl;
var scrolling = false;
var lastAutoScrollX;
var lastAutoScrollY;
var touchEvt$1;
var pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on2(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on2(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on2(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on2(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x2, y);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x2 !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x2, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x2;
          lastAutoScrollY = y;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll) return;
  var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x2) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x2) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
var sortable_esm_default = Sortable;

// js/hooks/drag_drop.js
var CSS_CLASSES = {
  DRAGGABLE: ".gc-draggable",
  GHOST: "gc-sortable-ghost",
  CHOSEN: "gc-sortable-chosen",
  DRAG: "gc-sortable-drag",
  PLACEHOLDER: ".gc-dropzone-placeholder",
  EMPTY_MESSAGE: ".gc-drag-empty",
  CONDENSED_CARD: ".gc-condensed-card",
  DROPZONE: ".gc-dropzone"
};
var getPlaceholder = (container) => container.querySelector(CSS_CLASSES.PLACEHOLDER);
var getEmptyMessage = (container) => container.querySelector(CSS_CLASSES.EMPTY_MESSAGE);
var getDraggableElements = (container) => container.querySelectorAll(CSS_CLASSES.CONDENSED_CARD);
var getDropzone = (id) => document.getElementById(id);
var setElementVisibility = (element, visible) => {
  if (element) {
    if (visible) {
      element.style.display = "block";
      element.removeAttribute("hidden");
    } else {
      element.style.display = "none";
      element.setAttribute("hidden", "");
    }
  }
};
var updateEmptyState = (container) => {
  const draggableElements = getDraggableElements(container);
  const emptyMessage = getEmptyMessage(container);
  setElementVisibility(emptyMessage, draggableElements.length === 0);
};
var updateDropzoneVisibility = (dropzone, showPlaceholder = false) => {
  const placeholder = getPlaceholder(dropzone);
  const draggableElements = getDraggableElements(dropzone);
  const emptyMessage = getEmptyMessage(dropzone);
  setElementVisibility(placeholder, showPlaceholder);
  draggableElements.forEach((card) => setElementVisibility(card, !showPlaceholder));
  setElementVisibility(emptyMessage, !showPlaceholder && draggableElements.length === 0);
};
var togglePlaceholder = (dropzoneId, show) => {
  try {
    const dropzone = getDropzone(dropzoneId);
    if (dropzone) {
      updateDropzoneVisibility(dropzone, show);
    }
  } catch (error) {
    console.error(`Error ${show ? "showing" : "hiding"} placeholder:`, error);
  }
};
var drag_drop_default = {
  mounted() {
    const hook = this;
    const isSourceContainer = this.el.id === "draggable-pool" || this.el.dataset.dragSource === "true";
    const cloneCounters = {};
    const createSortableConfig = (onEndCallback) => ({
      animation: 150,
      delay: 50,
      sort: false,
      delayOnTouchOnly: true,
      group: isSourceContainer ? {
        name: "draggables",
        pull: "clone",
        put: false
      } : {
        name: "draggables",
        pull: false,
        put: true
      },
      draggable: CSS_CLASSES.DRAGGABLE,
      ghostClass: CSS_CLASSES.GHOST,
      chosenClass: CSS_CLASSES.CHOSEN,
      dragClass: CSS_CLASSES.DRAG,
      onChoose: (evt) => {
        evt.item.dataset.originalZone = evt.from.id;
      },
      onMove: (evt) => {
        const toIsSource = evt.to.id === "draggable-pool" || evt.to.dataset.dragSource === "true";
        if (toIsSource) return true;
        const existingClone = evt.to.querySelector(`[data-original-id="${evt.dragged.id}"]`);
        return !existingClone;
      },
      onStart: (evt) => {
        const dropzones = document.querySelectorAll(CSS_CLASSES.DROPZONE);
        dropzones.forEach((dropzone) => {
          if (dropzone.id !== evt.from.id) {
            togglePlaceholder(dropzone.id, true);
          }
        });
      },
      onAdd: (evt) => {
        var _a;
        const draggedId = processDraggedId(evt.item.id);
        const dropzoneId = evt.to.id;
        const draggableIndex = (_a = evt.newDraggableIndex) != null ? _a : 0;
        const originalZoneId = evt.item.dataset.originalZone;
        togglePlaceholder(dropzoneId, false);
        hook.pushEventTo(hook.el, "dropped", {
          draggedId,
          dropzoneId,
          draggableIndex,
          originalZoneId
        });
        if (originalZoneId === evt.to.id) {
          evt.item.remove();
          return false;
        }
        return true;
      },
      onEnd: (evt) => {
        delete evt.item.dataset.originalZone;
        const fromIsSource = evt.from.id === "draggable-pool" || evt.from.dataset.dragSource === "true";
        const toIsSource = evt.to.id === "draggable-pool" || evt.to.dataset.dragSource === "true";
        if (fromIsSource && !toIsSource) {
          const originalId = evt.item.id;
          const tempClone = evt.from.querySelector(`[data-temp-clone-for="${originalId}"]`);
          if (tempClone) {
            tempClone.id = originalId;
            delete tempClone.dataset.tempCloneFor;
          }
          const baseId = processDraggedId(originalId);
          if (!cloneCounters[baseId]) cloneCounters[baseId] = 0;
          cloneCounters[baseId]++;
          evt.item.id = `${originalId}-clone-${cloneCounters[baseId]}`;
          evt.item.dataset.isClone = "true";
          evt.item.dataset.originalId = originalId;
        }
        const allPlaceholders = document.querySelectorAll(CSS_CLASSES.PLACEHOLDER);
        allPlaceholders.forEach((placeholder) => {
          setElementVisibility(placeholder, false);
        });
        const dropzones = document.querySelectorAll(CSS_CLASSES.DROPZONE);
        dropzones.forEach(updateEmptyState);
        if (onEndCallback) {
          onEndCallback(evt);
        }
      },
      onClone: (evt) => {
        const originalId = evt.item.id;
        evt.clone.id = `${originalId}-temp-clone`;
        evt.clone.dataset.tempCloneFor = originalId;
      }
    });
    const processDraggedId = (draggedId) => draggedId.replace(/^gc-draggable-/, "").replace(/-clone(-\d+)?$/, "");
    this.handleEvent("cleanup_clones", ({ dropzoneId }) => {
      const dropzone = getDropzone(dropzoneId);
      if (dropzone) {
        dropzone.querySelectorAll('[data-is-clone="true"]').forEach((el) => el.remove());
      }
    });
    this.sortable = new sortable_esm_default(this.el, createSortableConfig());
  },
  destroyed() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }
};

// js/hooks/remove-me.js
var GC_RemoveMe = {
  mounted() {
    this.el.addEventListener("click", () => {
      alert("Clicked");
    });
  }
};
var remove_me_default = GC_RemoveMe;

// js/hooks/index.js
var hooks_default = {
  GC_ActionMenu: action_menu_default,
  GC_ButtonGroup: button_group_default,
  GC_CancelInput: cancel_input_default,
  GC_Chip: chip_default,
  GC_Combobox: combobox_default,
  GC_DatePicker: date_picker_default,
  GC_DateRangePicker: date_range_picker_default,
  GC_FilterDateRangePicker: filter_date_range_picker_default,
  GC_DocumentPreview: document_preview_default,
  GC_DisableAutofill: disable_autofill_default,
  GC_DragDrop: drag_drop_default,
  GC_Dropdown: dropdown_default,
  GC_ErrorSummary: error_summary_default,
  GC_KeyboardNavigation: keyboard_navigation_default,
  GC_LiveSearch: live_search_default,
  GC_Modal: modal_default,
  GC_MoneyFormatting: money_formatting_default,
  GC_PasswordVisibility: password_visibility_default,
  GC_PickerCard: picker_card_default,
  GC_PickerCardGroup: picker_card_group_default,
  GC_RemoveMe: remove_me_default,
  GC_Select: select_default,
  GC_Table: table_default,
  GC_Tabs: tabs_default,
  GC_CustomTimeInput: custom_time_input_default,
  GC_Toggle: toggle_default,
  GC_Tooltip: tooltip_default,
  GC_Flash: flash_default
};

// js/design_system.js
var attachListeners = () => {
  window.addEventListener("gc:show-dialog-modal", ({ target }) => {
    target.showModal();
    liveSocket.execJS(target, target.dataset.show);
  });
  window.addEventListener("gc:hide-dialog-modal", ({ target }) => {
    target.close();
    liveSocket.execJS(target, target.dataset.hide);
  });
  window.addEventListener("gc:position-disclosure", (event) => {
    const { target: trigger, detail } = event;
    const placement = (detail == null ? void 0 : detail.placement) || "bottom";
    const fallbackPlacements = (detail == null ? void 0 : detail.fallbackPlacements) || "top";
    const menu = document.getElementById(trigger.getAttribute("popovertarget"));
    autoUpdate(trigger, menu, () => {
      if (trigger.getAttribute("aria-expanded") === "false") return;
      computePosition2(trigger, menu, {
        placement,
        middleware: [flip2({ fallbackPlacements }), shift2()]
      }).then(({ x: x2, y }) => {
        Object.assign(menu.style, {
          left: `${x2}px`,
          top: `${y}px`
        });
      });
    });
  });
  window.addEventListener("gc:close-disclosure", (event) => {
    document.getElementById(event.detail.id).hidePopover();
  });
  window.addEventListener("gc:toggle-disclosure", (event) => {
    const menu = document.getElementById(event.detail.id);
    const { show, hide: hide2 } = event.target.dataset;
    liveSocket.execJS(event.target, menu.matches(":popover-open") ? hide2 : show);
  });
};
export {
  hooks_default as Hooks,
  attachListeners
};
/*! Bundled license information:

sortablejs/modular/sortable.esm.js:
  (**!
   * Sortable 1.15.7
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   *)
*/
